// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/icomoon.ttf?mw673m", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/icomoon.woff?mw673m", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/fonts/icomoon.svg?mw673m", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/fonts/Filson/FilsonPro-Bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/fonts/Filson/FilsonPro-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../assets/fonts/Filson/FilsonPro-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../assets/fonts/Filson/FilsonPro-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../assets/fonts/Filson/FilsonPro-Light.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../assets/fonts/Filson/FilsonPro-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../assets/fonts/Filson/FilsonPro-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../assets/fonts/Filson/FilsonPro-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../assets/fonts/Filson/FilsonPro-Regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../assets/fonts/Filson/FilsonPro-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../assets/fonts/Filson/FilsonPro-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../assets/fonts/Filson/FilsonPro-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../assets/fonts/Filson/FilsonPro-Medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../assets/fonts/Filson/FilsonPro-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../assets/fonts/Filson/FilsonPro-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../assets/fonts/Filson/FilsonPro-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../assets/fonts/Omnes/Omnes-SemiBold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../assets/fonts/Omnes/Omnes-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../assets/fonts/Omnes/Omnes-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../assets/fonts/Omnes/Omnes-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../assets/fonts/Omnes/Omnes-Bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../assets/fonts/Omnes/Omnes-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../assets/fonts/Omnes/Omnes-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../assets/fonts/Omnes/Omnes-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../assets/fonts/Omnes/Omnes-Regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../assets/fonts/Omnes/Omnes-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../assets/fonts/Omnes/Omnes-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../assets/fonts/Omnes/Omnes-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("../assets/images/pictos/modal-alert.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("../assets/images/pictos/outil-share.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("../assets/images/pictos/outil-record.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("../assets/images/pictos/outil-snapshoot.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("../assets/images/pictos/outil-micro.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("../assets/images/pictos/outil-speaker.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___, { hash: "#icomoon" });
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
nav,
section,
summary {
  display: block;
}

audio,
canvas,
video {
  display: inline-block;
}

audio:not([controls]) {
  display: none;
  height: 0;
}

[hidden], template {
  display: none;
}

html {
  background: #fff;
  color: #000;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
}

html,
button,
input,
select,
textarea {
  font-family: sans-serif;
}

body {
  margin: 0;
}

a {
  background: transparent;
}
a:focus {
  outline: thin dotted;
}
a:hover, a:active {
  outline: 0;
}

h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

h2 {
  font-size: 1.5em;
  margin: 0.83em 0;
}

h3 {
  font-size: 1.17em;
  margin: 1em 0;
}

h4 {
  font-size: 1em;
  margin: 1.33em 0;
}

h5 {
  font-size: 0.83em;
  margin: 1.67em 0;
}

h6 {
  font-size: 0.75em;
  margin: 2.33em 0;
}

abbr[title] {
  border-bottom: 1px dotted;
}

b,
strong {
  font-weight: bold;
}

dfn {
  font-style: italic;
}

mark {
  background: #ff0;
  color: #000;
}

code,
kbd,
pre,
samp {
  font-family: monospace, serif;
  font-size: 1em;
}

pre {
  white-space: pre;
  white-space: pre-wrap;
  word-wrap: break-word;
}

q {
  quotes: "“" "”" "‘" "’";
}

q:before, q:after {
  content: "";
  content: none;
}

small {
  font-size: 80%;
}

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sup {
  top: -0.5em;
}

sub {
  bottom: -0.25em;
}

img {
  border: 0;
}

svg:not(:root) {
  overflow: hidden;
}

figure {
  margin: 0;
}

fieldset {
  border: 1px solid #c0c0c0;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em;
}

legend {
  border: 0;
  padding: 0;
  white-space: normal;
}

button,
input,
select,
textarea {
  font-family: inherit;
  font-size: 100%;
  margin: 0;
  vertical-align: baseline;
}

button, input {
  line-height: normal;
}

button,
select {
  text-transform: none;
}

button,
html input[type=button],
input[type=reset],
input[type=submit] {
  -webkit-appearance: button;
  cursor: pointer;
}

button[disabled],
input[disabled] {
  cursor: default;
}

button::-moz-focus-inner, input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

textarea {
  overflow: auto;
  vertical-align: top;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

input[type=search] {
  -webkit-appearance: textfield;
  box-sizing: content-box;
}
input[type=search]::-webkit-search-cancel-button, input[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}
input[type=checkbox], input[type=radio] {
  box-sizing: border-box;
  padding: 0;
}

@font-face {
  font-family: "icomoon";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
[class^=icon-],
[class*=" icon-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icomoon" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.device-item-icon [class^=icon-]:before,
.device-item-icon [class*=" icon-"]:before {
  content: "\\e946";
}

.device-item-icon .icon-default:before,
.icon-default:before {
  content: "\\e946";
}

.device-item-icon .icon-camera-deportee:before,
.icon-camera-deportee:before {
  content: "\\e947";
}

.device-item-icon .icon-medical-info:before,
.icon-medical-info:before {
  content: "\\e945";
}

.device-item-icon .icon-plus:before,
.icon-plus:before {
  content: "\\e944";
}

.device-item-icon .icon-minus:before,
.icon-minus:before {
  content: "\\e943";
}

.device-item-icon .icon-fullscreen:before,
.icon-fullscreen:before {
  content: "\\e941";
}

.device-item-icon .icon-fullscreen_exit:before,
.icon-fullscreen_exit:before {
  content: "\\e942";
}

.device-item-icon .icon-cake:before,
.icon-cake:before {
  content: "\\e93a";
}

.device-item-icon .icon-gender:before,
.icon-gender:before {
  content: "\\e93b";
}

.device-item-icon .icon-glycemie:before,
.icon-glycemie:before {
  content: "\\e93c";
}

.device-item-icon .icon-meter:before,
.icon-meter:before {
  content: "\\e93d";
}

.device-item-icon .icon-oxymetrie:before,
.icon-oxymetrie:before {
  content: "\\e93e";
}

.device-item-icon .icon-temp:before,
.icon-temp:before {
  content: "\\e93f";
}

.device-item-icon .icon-weight:before,
.icon-weight:before {
  content: "\\e940";
}

.device-item-icon .icon-doc2u:before,
.icon-doc2u:before {
  content: "\\e900";
}

.device-item-icon .icon-cam:before,
.icon-cam:before {
  content: "\\e901";
}

.device-item-icon .icon-camera:before,
.icon-camera:before {
  content: "\\e902";
}

.device-item-icon .icon-cam-off:before,
.icon-cam-off:before {
  content: "\\e903";
}

.device-item-icon .icon-cancel:before,
.icon-cancel:before {
  content: "\\e904";
}

.device-item-icon .icon-check:before,
.icon-check:before {
  content: "\\e905";
}

.device-item-icon .icon-checkbox:before,
.icon-checkbox:before {
  content: "\\e906";
}

.device-item-icon .icon-checkbox-checked:before,
.icon-checkbox-checked:before {
  content: "\\e907";
}

.device-item-icon .icon-chevron-down:before,
.icon-chevron-down:before {
  content: "\\e908";
}

.device-item-icon .icon-chevron-up:before,
.icon-chevron-up:before {
  content: "\\e909";
}

.device-item-icon .icon-dermatoscope:before,
.icon-dermatoscope:before {
  content: "\\e90a";
}

.device-item-icon .icon-docs:before,
.icon-docs:before {
  content: "\\e90b";
}

.device-item-icon .icon-download:before,
.icon-download:before {
  content: "\\e90c";
}

.device-item-icon .icon-download-zip:before,
.icon-download-zip:before {
  content: "\\e90d";
}

.device-item-icon .icon-echographe-doppler:before,
.icon-echographe-doppler:before {
  content: "\\e90e";
}

.device-item-icon .icon-electrocardiogramme:before,
.icon-electrocardiogramme:before {
  content: "\\e90f";
}

.device-item-icon .icon-exit:before,
.icon-exit:before {
  content: "\\e910";
}

.device-item-icon .icon-expand:before,
.icon-expand:before {
  content: "\\e911";
}

.device-item-icon .icon-file-audio:before,
.icon-file-audio:before {
  content: "\\e912";
}

.device-item-icon .icon-file-camera:before,
.icon-file-camera:before {
  content: "\\e913";
}

.device-item-icon .icon-file-doc:before,
.icon-file-doc:before {
  content: "\\e914";
}

.device-item-icon .icon-file-link:before,
.icon-file-link:before {
  content: "\\e915";
}

.device-item-icon .icon-file-pdf:before,
.icon-file-pdf:before {
  content: "\\e916";
}

.device-item-icon .icon-file-video:before,
.icon-file-video:before {
  content: "\\e917";
}

.device-item-icon .icon-focus:before,
.icon-focus:before {
  content: "\\e918";
}

.device-item-icon .icon-hangup:before,
.icon-hangup:before {
  content: "\\e919";
}

.device-item-icon .icon-menu:before,
.icon-menu:before {
  content: "\\e91a";
}

.device-item-icon .icon-messages:before,
.icon-messages:before {
  content: "\\e91b";
}

.device-item-icon .icon-messages-off:before,
.icon-messages-off:before {
  content: "\\e91c";
}

.device-item-icon .icon-mic:before,
.icon-mic:before {
  content: "\\e91d";
}

.device-item-icon .icon-mic-off:before,
.icon-mic-off:before {
  content: "\\e91e";
}

.device-item-icon .icon-otoscope:before,
.icon-otoscope:before {
  content: "\\e91f";
}

.device-item-icon .icon-phone-ring:before,
.icon-phone-ring:before {
  content: "\\e920";
}

.device-item-icon .icon-print:before,
.icon-print:before {
  content: "\\e921";
}

.device-item-icon .icon-record:before,
.icon-record:before {
  content: "\\e922";
}

.device-item-icon .icon-recorded:before,
.icon-recorded:before {
  content: "\\e923";
}

.device-item-icon .icon-screenshare:before,
.icon-screenshare:before {
  content: "\\e924";
}

.device-item-icon .icon-screenshare-off:before,
.icon-screenshare-off:before {
  content: "\\e925";
}

.device-item-icon .icon-settings:before,
.icon-settings:before {
  content: "\\e926";
}

.device-item-icon .icon-spirometre:before,
.icon-spirometre:before {
  content: "\\e927";
}

.device-item-icon .icon-trash:before,
.icon-trash:before {
  content: "\\e928";
}

.device-item-icon .icon-trombone:before,
.icon-trombone:before {
  content: "\\e929";
}

.device-item-icon .icon-view:before,
.icon-view:before {
  content: "\\e92a";
}

.device-item-icon .icon-warning:before,
.icon-warning:before {
  content: "\\e92b";
}

.device-item-icon .icon-plane:before,
.icon-plane:before {
  content: "\\e92c";
}

.device-item-icon .icon-stethoscope:before,
.icon-stethoscope:before {
  content: "\\e92d";
}

.device-item-icon .icon-speaker:before,
.icon-speaker:before {
  content: "\\e92e";
}

.device-item-icon .icon-quality-down:before,
.icon-quality-down:before {
  content: "\\e92f";
}

.device-item-icon .icon-quality-up:before,
.icon-quality-up:before {
  content: "\\e930";
}

.device-item-icon .icon-speaker-alt:before,
.icon-speaker-alt:before {
  content: "\\e931";
}

.device-item-icon .icon-volume-down:before,
.icon-volume-down:before {
  content: "\\e932";
}

.device-item-icon .icon-volume-up:before,
.icon-volume-up:before {
  content: "\\e933";
}

.device-item-icon .icon-speaker-off:before,
.icon-speaker-off:before {
  content: "\\e934";
}

.device-item-icon .icon-exclamation:before,
.icon-exclamation:before {
  content: "\\e935";
}

.device-item-icon .icon-back:before,
.icon-back:before {
  content: "\\e936";
}

.device-item-icon .icon-hamburger:before,
.icon-hamburger:before {
  content: "\\e937";
}

.device-item-icon .icon-flashlight:before,
.icon-flashlight:before {
  content: "\\e938";
}

.device-item-icon .icon-switchcam:before,
.icon-switchcam:before {
  content: "\\e939";
}

@font-face {
  font-family: "Filson Pro";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Filson Pro";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("truetype");
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Filson Pro";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("truetype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Filson Pro";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("truetype");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Omnes";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("truetype");
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Omnes";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("truetype");
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Omnes";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_34___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_35___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_36___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_37___}) format("truetype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
[class^=picto-], [class*=" picto-"] {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

.picto-modal-alert {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
}

.picto-outil-share {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
}

.picto-outil-record {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
}

.picto-outil-snapshoot {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
}

.picto-outil-micro {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
}

.picto-outil-speaker {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
}

.button {
  display: inline-block;
  margin-bottom: 0;
  font-family: "Exo", sans-serif;
  line-height: 1.2;
  text-align: center;
  vertical-align: middle;
  font-weight: 600;
  font-size: 1.125rem;
  padding: 0.625rem;
  /*padding: 0.25rem 2rem;
  font-size: 0.875rem;
     font-weight: 500;*/
  cursor: pointer;
  background: #FDFBFB;
  border: 1px solid transparent;
  border-radius: 1rem;
  box-shadow: none;
  outline: none;
  color: #000000;
  transition: all 0.3s linear;
}
.button--medical {
  font-family: "Omnes", sans-serif;
  font-weight: 600;
  padding-top: 0.125rem;
  font-size: 1rem;
}
.button:hover, .button:focus {
  color: #000000;
  text-decoration: none;
}
.button.active, .button:active {
  outline: none;
  box-shadow: none;
}
.button.disabled, .button[disabled] {
  cursor: not-allowed;
  opacity: 0.65;
}

.button--primary {
  color: #FDFBFB;
  background: #1DADB5;
  border-color: #1DADB5;
}
.button--primary:hover, .button--primary:focus {
  color: #FDFBFB;
  background: rgb(21.9571428571, 130.9857142857, 137.0428571429);
  border-color: rgb(21.9571428571, 130.9857142857, 137.0428571429);
}
.button--primary.button--medical {
  background: #1DADB5;
  border-color: #1DADB5;
}
.button--primary.button--medical:hover, .button--primary.button--medical:focus {
  background: rgb(21.9571428571, 130.9857142857, 137.0428571429);
  border-color: rgb(21.9571428571, 130.9857142857, 137.0428571429);
}
.button--primary.button--outline {
  background: #FDFBFB;
  color: #1DADB5;
}
.button--primary.button--outline:hover, .button--primary.button--outline:focus {
  background: #FDFBFB;
  color: rgb(21.9571428571, 130.9857142857, 137.0428571429);
}
.button--primary.button--outline.button--medical {
  border-width: 2px;
  border-color: #00666F;
  color: #00666F;
}
.button--primary.button--outline.button--medical:hover, .button--primary.button--outline.button--medical:focus {
  border-color: rgb(0, 148.8648648649, 162);
  color: rgb(0, 148.8648648649, 162);
}

.button--dark {
  color: #FDFBFB;
  background: #000000;
  border-color: #000000;
}
.button--dark:hover, .button--dark:focus {
  color: #FDFBFB;
  background: black;
  border-color: black;
}
.button--dark.button--outline {
  background: #FDFBFB;
  color: #000000;
}
.button--dark.button--outline:hover, .button--dark.button--outline:focus {
  background: #FDFBFB;
  color: black;
}

.button--danger {
  color: #FDFBFB;
  background: #FF4958;
  border-color: #FF4958;
}
.button--danger:hover, .button--danger:focus {
  color: #FDFBFB;
  background: rgb(255, 22, 41.2032967033);
  border-color: rgb(255, 22, 41.2032967033);
}
.button--danger.button--outline {
  background: #FDFBFB;
  color: #FF4958;
}
.button--danger.button--outline:hover, .button--danger.button--outline:focus {
  background: #FDFBFB;
  color: rgb(255, 22, 41.2032967033);
}

.button--warning {
  color: #FDFBFB;
  background: #F4981C;
  border-color: #F4981C;
}
.button--warning:hover, .button--warning:focus {
  color: #FDFBFB;
  background: rgb(210.7857142857, 125.3571428571, 10.2142857143);
  border-color: rgb(210.7857142857, 125.3571428571, 10.2142857143);
}
.button--warning.button--outline {
  background: #FDFBFB;
  color: #F4981C;
}
.button--warning.button--outline:hover, .button--warning.button--outline:focus {
  background: #FDFBFB;
  color: rgb(210.7857142857, 125.3571428571, 10.2142857143);
}

.progress {
  display: block;
  width: 100%;
  text-align: center;
  font-size: 0.75rem;
  font-weight: 600;
}
.progress__bar {
  border: 1px solid #1DADB5;
  background: #FDFBFB;
  height: 0.75rem;
  border-radius: 0.375rem;
  position: relative;
}
.progress__value {
  background: #1DADB5;
  height: 100%;
  margin: 0px;
  transition: width 0.3s ease-in-out;
  border-radius: inherit;
}
.progress.progress--textinside {
  position: relative;
}
.progress.progress--textinside .progress__text {
  position: absolute;
  top: 2px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 0.5rem;
  color: #FDFBFB;
  z-index: 1;
}
.progress.progress--light {
  color: #FDFBFB;
}
.progress.progress--light .progress__bar {
  border-color: #FDFBFB;
  background: #1DADB5;
}
.progress.progress--light .progress__value {
  background: #FDFBFB;
}
.progress.progress--textinside .progress__text {
  color: #1DADB5;
}

.range__input {
  width: 100%;
  -webkit-appearance: none;
  box-shadow: none;
  border: none;
  height: 0.625rem;
  background: #FDFBFB;
  border-radius: 1rem;
  border: 1px solid #1DADB5;
  border-width: 0.5px;
  background-image: linear-gradient(#1DADB5, #1DADB5);
  background-repeat: no-repeat;
}
.range__input::-webkit-slider-thumb {
  -webkit-appearance: none;
  height: 1.125rem;
  width: 1.125rem;
  border-radius: 50%;
  background: #FDFBFB;
  cursor: pointer;
  box-shadow: none;
  border: 2px solid #1DADB5;
  border-radius: 1.5px;
  border-radius: 50%;
}
.range__input::-webkit-slider-runnable-track {
  -webkit-appearance: none;
  box-shadow: none;
  border: none;
  background: transparent;
}
.range.muted {
  cursor: default;
  opacity: 0.7;
}
.range.muted::-webkit-slider-thumb, .range.muted::-webkit-slider-runnable-track {
  cursor: default !important;
}
.range.muted .range-plus, .range.muted .range-moins {
  cursor: default !important;
  opacity: 0.7;
}

.icon-range {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}
.icon-range__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.875rem;
  height: 1.875rem;
  background: #FDFBFB;
  border-radius: 50%;
  border: 1px solid #1DADB5;
  border-width: 0.5px;
  margin-right: 0.625rem;
}
.icon-range__icon .picto-outil-speaker {
  width: 1.25rem;
  height: 1.25rem;
}
.icon-range__input {
  flex: 1 1 auto;
}
.icon-range.icon-range--vertical {
  flex-direction: column;
}
.icon-range.icon-range--vertical .icon-range__icon {
  margin-right: 0px;
  margin-bottom: 0.625rem;
}
.icon-range.icon-range--vertical .icon-range__input {
  transform: rotate(-90deg);
  padding-bottom: 25%;
  padding-top: 25%;
}

.range-plus, .range-moins {
  display: none;
}

.volume-control {
  max-width: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin: 5px 0px 5px 1rem;
}
.volume-control .volume-control__mute {
  margin: 0px 0.125rem 0px 0px;
  width: 1.875rem;
  height: 1.875rem;
  line-height: 1.875rem;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FDFBFB;
  border: 1px solid #1DADB5;
  border-radius: 50%;
  outline: none;
  box-shadow: none;
  font-size: 1rem;
  color: #00666F;
}
.volume-control .volume-control__mute.muted {
  color: #FF4958;
  border-color: #FF4958;
}
.volume-control .range {
  width: 16rem;
}
.volume-control .range .range-plus,
.volume-control .range .range-moins {
  -webkit-user-select: none;
          user-select: none;
  content: "";
  display: none;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
  height: 1.25rem;
  position: absolute;
  background: rgba(253, 251, 251, 0.8);
  color: #1DADB5;
  border-radius: 0.25rem;
  font-size: 1.5rem;
  cursor: pointer;
}
.volume-control .range .range-plus {
  right: -2rem;
}
.volume-control .range .range-moins {
  left: -2rem;
  bottom: 0;
  transform: rotate(-90deg);
}
@media (max-width: 767px), (max-height: 575px) {
  .volume-control .range {
    width: 7rem;
  }
}

.video-block {
  position: relative;
  border-radius: 1.25rem;
  overflow: hidden;
  width: 100%;
}
.video-block + .video-block {
  margin-top: 1rem;
}
.video-block .video-block__video {
  height: auto;
  margin: 0px;
  display: block;
  width: 100%;
}
.video-block .video-block__placeholder {
  position: absolute;
  z-index: 2;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  color: #FDFBFB;
  display: flex;
  align-items: center;
  justify-content: center;
}
.video-block .video-block__scale {
  width: 1.625rem;
  height: 1.625rem;
  padding: 0;
  border-radius: 50%;
  border: none;
  outline: none;
  box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.25);
  background: rgba(253, 251, 251, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333c50;
  font-size: 1rem;
  position: absolute;
  top: 0.6125rem;
  right: 0.6125rem;
  z-index: 3;
  transition: all 0.3s linear;
  border: 1px solid #333c50;
  border-width: 1.5px;
}
.video-block .video-block__scale:hover {
  background: #FDFBFB;
}
.video-block .video-block__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  position: absolute;
  top: 0;
}
.video-block.video-block--nocamera .video-block__video {
  display: none;
}
.video-block .audio-meter-container {
  position: absolute;
  bottom: 1.5rem;
  left: 0px;
  right: 0px;
  z-index: 1;
}
.video-block .audio-meter-container.audio-meter-container--vertical {
  bottom: 1.5rem;
  top: 1.5rem;
  height: auto;
  right: 1.5rem;
  left: auto;
}
.video-block .video-block__muted {
  position: absolute;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  z-index: 2;
  color: #FDFBFB;
  font-size: 3rem;
  font-size: 5vw;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0.5;
}
@media (max-width: 991px), (max-height: 699px) {
  .video-block .video-block__scale {
    width: 1.25rem;
    height: 1.25rem;
    font-size: 0.75rem;
  }
}

.alert {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  width: 100%;
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
  background: #ffffff;
  color: #FF4958;
  font-size: inherit;
  font-weight: 600;
  margin: 0px auto 1rem;
}
.alert .alert__icon {
  font-size: 1.5rem;
  margin-right: 0.5rem;
}

.audio-meter-container {
  width: 100%;
  height: 0.5rem;
  border: 1px solid #1DADB5;
  background: #FDFBFB;
  border-radius: 0.25rem;
  overflow: hidden;
}
.audio-meter-container .audio-meter-inner {
  height: 100%;
  background: #1DADB5;
  transition: width 0.3s linear;
}
.audio-meter-container.audio-meter-container--vertical {
  width: 0.5rem;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.audio-meter-container.audio-meter-container--vertical .audio-meter-inner {
  width: 100%;
  height: auto;
  margin-top: auto;
  margin-bottom: 0;
}

@keyframes spinnerAnim {
  100% {
    transform: rotate(360deg);
  }
}
.loader {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 110;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
}
.loader .loader__inner {
  background: #FDFBFB;
  width: 12.5rem;
  height: 12.5rem;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loader .loader__spinner {
  width: 50%;
  height: 50%;
  border-radius: 50%;
  border: 0.375rem solid #1DADB5;
  border-bottom-color: transparent;
  border-top-color: transparent;
  animation: spinnerAnim 2s infinite linear;
}

.tabs {
  max-width: 31.5rem;
  margin: 0px auto;
  flex: 1 0 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  justify-content: center;
  position: relative;
}
.tabs::after {
  content: "";
  display: block;
  width: 100%;
  height: 1px;
  background: #EEE7E1;
  position: absolute;
  bottom: -1px;
  left: 0px;
}
.tabs .tab {
  cursor: pointer;
  flex: 1 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FDFBFB;
  border-radius: 1rem 1rem 0px 0px;
  padding: 0.625rem 1.875rem;
  box-shadow: 1px 0px 2px rgba(0, 0, 0, 0.3);
  font-size: 1rem;
  border-bottom: 3px solid transparent;
}
.tabs .tab.active {
  border-bottom-color: #F4981C;
}
.tabs .tab span {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
}
.tabs .tab + .tab {
  margin-left: 0.75rem;
}
.tabs .tab i {
  margin-right: 0.25rem;
}
@media (max-width: 575px) {
  .tabs {
    flex-wrap: nowrap;
    max-width: 100%;
    width: 100%;
    padding-top: 0.75rem;
  }
  .tabs::after {
    top: 0px;
    bottom: auto;
    left: -0.75rem;
    right: -0.75rem;
    width: auto;
    box-shadow: 0px -1px 2px rgba(0, 0, 0, 0.3);
  }
  .tabs .tab {
    padding: 0.25rem 1.25rem;
    border-radius: 0px;
    box-shadow: none;
    font-size: 0.875rem;
    flex: 0 0 auto;
  }
  .tabs .tab span {
    flex-direction: column;
  }
}

.tab-content {
  padding: 1.625rem 0.5rem;
}

@media (max-width: 575px) {
  .tabs-wrapper {
    display: flex;
    flex-direction: column;
  }
  .tabs-wrapper .tabs {
    margin-top: auto;
    order: 2;
    flex: 0 0 auto;
  }
  .tabs-wrapper .tab-content {
    order: 1;
    flex: 1 1 auto;
    overflow: hidden;
    overflow-y: auto;
  }
}

.flashlight-toggle {
  position: absolute;
  top: 1rem;
  left: 1rem;
  z-index: 2;
  width: 2.5rem;
  height: 2.5rem;
  border: 2px solid #FDFBFB;
  color: #FDFBFB;
  background: rgba(253, 251, 251, 0.3);
  border-radius: 50%;
  box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.25);
  font-size: 1.5rem;
  display: none;
  align-items: center;
  justify-content: center;
}
.flashlight-toggle:hover {
  background: rgba(253, 251, 251, 0.4);
}
.flashlight-toggle--active {
  background: #F4981C;
  border-color: #F4981C;
}
.flashlight-toggle--active:hover {
  background: rgb(210.7857142857, 125.3571428571, 10.2142857143);
  border-color: rgb(210.7857142857, 125.3571428571, 10.2142857143);
}
@media (max-width: 575px) {
  .flashlight-toggle {
    display: flex;
  }
}

.fieldset {
  margin: 0px 0px 0.625rem;
}
.fieldset__title {
  font-family: "Filson Pro", sans-serif;
  font-weight: 500;
  font-size: 1rem;
  line-height: 1;
  text-align: center;
  vertical-align: middle;
  margin: 0px 0px 0.625rem;
}
.fieldset__inner {
  border-radius: 1rem;
  padding: 0.625rem;
  border: 1px solid #959292;
}

.file-item-select {
  margin: 0px;
  padding: 0px 0px;
  list-style-type: none;
  overflow: auto;
  height: 100%;
}

.file-item-option {
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  font-size: 1rem;
  padding: 0.25rem 0.75rem 0.25rem 0px;
}
.file-item-option__input {
  margin: 0px;
  margin-right: 0.625rem;
  flex: 0 0 1.125rem;
  width: 1rem;
  height: 1rem;
  border: 2px solid #1DADB5;
}
.file-item-option__icon {
  flex: 0 0 1.125rem;
  color: #F4981C;
  margin-right: 0.75rem;
}
.file-item-option__label {
  font-weight: 500;
  flex: 1 1 auto;
}
.file-item-option__preview, .file-item-option__download {
  cursor: pointer;
  flex: 0 0 1.125rem;
  font-size: 1.125rem;
}
.file-item-option__preview {
  margin-right: 0.75rem;
}

.input-file-custom {
  display: inline-block;
  margin: 0px auto;
  position: relative;
}
.input-file-custom__input {
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  z-index: 1;
  opacity: 0;
}

.form-input {
  width: 100%;
  max-width: 303px;
  margin-bottom: 0.75rem;
}
.doctor-form .form-input {
  margin-bottom: 0.5rem;
}
.form-input--date {
  max-width: 131px;
}
.form-input--zipcode {
  max-width: 140px;
}
.form-input--select, .form-input--upload, .form-input--multiselect-files, .form-input--motif_consultation {
  max-width: 100%;
  flex: 1 1 auto;
}
.form-input--textarea {
  max-width: 100%;
  flex: 1 1 auto;
}
.form-input--textarea .form-input__input {
  height: 6.5rem;
}
.form-input__label {
  display: block;
  font-family: "Omnes", sans-serif;
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.1;
  margin: 0px 0px 0.5rem;
}
.doctor-form .form-input__label {
  margin-bottom: 0.25rem;
}
.form-input__label small {
  font-weight: 400;
  font-size: 1rem;
  margin-left: 0.5rem;
}
.form-input__input {
  display: block;
  width: 100%;
  margin: 0px;
  border-radius: 1rem;
  padding: 0.375rem 1rem;
  box-shadow: 0px 1px 4px 1px rgba(0, 0, 0, 0.21) inset;
  font-family: "Omnes", sans-serif;
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.1;
  color: #00666F;
  border: none;
  outline: none;
}
.form-input__input::placeholder {
  color: #00666F;
}
.form-input__input__error {
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.21) inset;
  border: 0.2rem solid #FF4958;
}
.form-input__multiselect {
  width: 100%;
  padding: 0.375rem 1.25rem;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.25) inset;
  border-radius: 1.5rem;
  background: #FDFBFB;
  height: 100px;
  overflow: hidden;
}
.form-input__description {
  margin: 0px 0px 0.75rem;
}
.form-input__file {
  text-align: center;
}
.form-input__select {
  background: #FDFBFB;
  border: 1px solid #AAA5A4;
  width: 100%;
  padding: 0.375rem 1rem;
  border-radius: 1.5rem;
  font-family: "Omnes", sans-serif;
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1;
  color: #00666F;
}

* {
  box-sizing: border-box;
}

html {
  font-size: 1rem;
}

body {
  margin: 0;
  font-family: "Exo", sans-serif;
  font-size: inherit;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: fixed;
  width: 100%;
  max-height: 100%;
}
body.demo-page {
  max-height: inherit;
  position: relative;
  overflow-y: auto;
}

h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  font-family: "Exo", sans-serif;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

*::-webkit-scrollbar {
  width: 5px;
  cursor: pointer;
}

*::-webkit-scrollbar-track {
  background: #EEE7E1;
}

*::-webkit-scrollbar-thumb {
  background: #697F8C;
}

.btn-icon {
  border-radius: 50%;
  border: none;
  color: #FDFBFB;
  background: #1DADB5;
}
.btn-icon.btn-size1 {
  width: 1rem;
  height: 1rem;
  line-height: 1rem;
}
.btn-icon.btn-size2 {
  width: 1.5rem;
  height: 1.5rem;
  line-height: 1.5rem;
}
.btn-icon.btn-size3 {
  width: 2.7504rem;
  height: 2.7504rem;
  line-height: 2.7504rem;
}
.btn-icon.btn-white {
  background: #FDFBFB;
  color: #1DADB5;
}

.documents {
  color: #00666F;
}
.documents .documents__header {
  text-align: center;
  margin-bottom: 1.25rem;
}
.documents .documents__title {
  font-size: 1.125rem;
  font-weight: 600;
  margin: 0.5rem 0px 0.5rem;
}
.documents .documents__subtitle {
  font-size: 0.875rem;
  font-weight: 500;
  margin: 0px auto;
  max-width: 29rem;
  line-height: 1.4;
}
.documents .documents__empty {
  font-weight: 600;
  text-align: center;
}
.documents .documents__listwrapper {
  max-height: 12.5rem;
  overflow: auto;
  width: 100%;
  box-shadow: inset 1px 1px 3px 1px rgba(0, 102, 111, 0.3);
  border-radius: 1rem;
}
.documents .documents__list {
  display: table;
  margin: 0px 0px 0.75rem;
  padding: 0px;
  width: 100%;
  overflow: hidden;
}
.documents .documents__listitem {
  display: table-row;
  position: relative;
}
.documents .documents__listitem + .documents__listitem::after {
  content: "";
  display: block;
  position: absolute;
  top: 0px;
  left: 1.25rem;
  right: 1.25rem;
  border-top: 1px solid #697F8C;
}
.documents .documents__listitem .listitem__cb {
  text-align: center;
  width: 1.75rem;
  padding-left: 0.875rem;
  /* Style pour la case non cochée */
  /* Style pour la case cochée */
}
.documents .documents__listitem .listitem__cb input {
  width: 1rem;
  height: 1rem;
  border-color: #00666F;
}
.documents .documents__listitem .listitem__cb input[type=checkbox] {
  /* Masquer l'input checkbox d'origine */
  display: none;
}
.documents .documents__listitem .listitem__cb input[type=checkbox] + label:before {
  content: "";
  width: 16px;
  height: 16px;
  display: inline-block;
  border-radius: 3px;
  margin-right: 10px;
  line-height: 20px;
  border: 1px solid #00666F;
  background-color: #fff;
}
.documents .documents__listitem .listitem__cb input[type=checkbox]:checked + label:before {
  content: "✓";
  /* Caractère unicode pour le symbole de coche */
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #F4981C;
}
.documents .documents__listitem .listitem__icon {
  width: 1.875rem;
  text-align: center;
  font-size: 1.125rem;
  color: #F4981C;
}
.documents .documents__listitem .listitem__name {
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
}
@media (max-width: 575px) {
  .documents .documents__listitem .listitem__name span {
    display: block;
    width: 37vw;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.documents .documents__listitem .listitem__actions {
  width: 8rem;
  padding-right: 1.5rem;
}
.documents .documents__listitem .listitem__action {
  text-decoration: none;
  color: inherit;
  outline: none;
  font-size: 1.125rem;
  margin: 0.125rem 0.25rem;
}
.documents .documents__listitem .listitem__action:hover {
  color: #1DADB5;
}
.documents .documents__listitem .listitem__action.item__action--delete:hover {
  color: #FF4958;
}
.documents .documents__listitem .listitem__action.item__action--empty {
  width: 18px;
  display: inline-block;
}
.documents .listitem__cell {
  display: table-cell;
  padding: 0.75rem 0.375rem;
  vertical-align: middle;
}
.documents .documents__groupactions {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
}
.documents .documents__groupactions .button {
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 0.625rem;
  font-weight: 600;
  /*.icon-trash {
    font-size: 0.875rem;
    position: relative;
    bottom: -0.125rem;
    height: 0.625rem;
    display: inline-block;
    margin-right: 0.375rem;
  }*/
}
.documents .documents__groupactions .button i {
  margin-right: 0.25rem;
}

.need-interaction {
  text-align: center;
  max-width: 32.625rem;
  margin: 0px auto;
}
.need-interaction p {
  font-weight: 600;
  font-size: 1.125rem;
  margin-bottom: 1.5rem;
}
.need-interaction .button {
  font-size: 1.125rem;
  padding: 0.625rem 1.25rem;
}

.settings-video .test-device__title,
.settings-audio .test-device__title,
.settings-support .test-device__title,
.test-device .test-device__title {
  text-align: center;
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0.25rem 0px 1.875rem;
}
.settings-video .test-device__start,
.settings-audio .test-device__start,
.settings-support .test-device__start,
.test-device .test-device__start {
  font-size: 1.125rem;
  padding: 0.625rem 1.25rem;
}
.settings-video .test-device__row,
.settings-audio .test-device__row,
.settings-support .test-device__row,
.test-device .test-device__row {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  width: 100%;
}
.settings-video .test-device__col,
.settings-audio .test-device__col,
.settings-support .test-device__col,
.test-device .test-device__col {
  padding: 0.5rem;
  flex: 0 0 50%;
  width: 50%;
}
.settings-video .settings__subtitle,
.settings-video .test-device__subtitle,
.settings-audio .settings__subtitle,
.settings-audio .test-device__subtitle,
.settings-support .settings__subtitle,
.settings-support .test-device__subtitle,
.test-device .settings__subtitle,
.test-device .test-device__subtitle {
  font-size: 1rem;
  font-weight: 600;
  margin: 0px auto 1rem;
  text-align: center;
}
.settings-video .test-device__start,
.settings-audio .test-device__start,
.settings-support .test-device__start,
.test-device .test-device__start {
  margin-top: 2.5rem;
  margin-left: auto;
  margin-right: auto;
  display: block;
  width: auto;
}
.settings-video .test-device__capteurs,
.settings-audio .test-device__capteurs,
.settings-support .test-device__capteurs,
.test-device .test-device__capteurs {
  padding-left: 1rem;
}
.settings-video.test-device--patient .test-device__col,
.settings-audio.test-device--patient .test-device__col,
.settings-support.test-device--patient .test-device__col,
.test-device.test-device--patient .test-device__col {
  flex: 0 0 33.33%;
  width: 33.33%;
}
@media (max-width: 767px), (max-height: 575px) {
  .settings-video .test-device__row,
  .settings-audio .test-device__row,
  .settings-support .test-device__row,
  .test-device .test-device__row {
    flex-wrap: wrap;
  }
  .settings-video .test-device__col,
  .settings-audio .test-device__col,
  .settings-support .test-device__col,
  .test-device .test-device__col {
    padding-left: 0px;
    padding-right: 0px;
    flex: 0 0 100%;
    width: 100%;
  }
  .settings-video.test-device--patient .test-device__col,
  .settings-audio.test-device--patient .test-device__col,
  .settings-support.test-device--patient .test-device__col,
  .test-device.test-device--patient .test-device__col {
    flex: 0 0 100%;
    width: 100%;
  }
}
@media (max-width: 575px) {
  .settings-video .test-device__col--capteurs,
  .settings-audio .test-device__col--capteurs,
  .settings-support .test-device__col--capteurs,
  .test-device .test-device__col--capteurs {
    display: none !important;
  }
}

.capteur-item {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  margin-bottom: 0.75rem;
}
.capteur-item__icon {
  display: flex;
  flex: 0 0 1.875rem;
  height: 1.875rem;
  align-items: center;
  justify-content: center;
  border: 1px solid #00666F;
  border-radius: 50%;
  font-size: 1.125rem;
  margin-right: 1rem;
}
.capteur-item__name {
  font-size: 0.875rem;
  font-family: "Omnes", sans-serif;
  font-weight: 600;
}
.capteur-item__status {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 0.25rem;
  width: 1.375rem;
  height: 1.375rem;
  border-radius: 50%;
  border: 2px solid #1DADB5;
  color: #1DADB5;
  font-size: 0.625rem;
  margin-left: auto;
}
.capteur-item--disabled .capteur-item__status {
  color: #FF4958;
  border-color: #FF4958;
}
.capteur-item--undefined .capteur-item__status {
  color: #F4981C;
  border-color: #F4981C;
}
.capteur-item--undefined .capteur-item__status .icon-exclamation {
  font-size: 150%;
}
.capteur-item__toggle {
  margin-left: 1.25rem;
  width: 52px;
}
@media (max-width: 767px), (max-height: 575px) {
  .capteur-item__toggle {
    margin-left: 0.75rem;
    width: 39px;
  }
  .capteur-item .device-toggle {
    width: 39px;
    height: 24px;
  }
  .capteur-item .device-toggle__content {
    width: 21px;
  }
}

.device-toggle {
  width: 52px;
  height: 32px;
  margin-left: auto;
  border-radius: 15px;
  display: flex;
  align-self: center;
}
.device-toggle--active {
  background-color: #1DADB5;
  justify-content: end;
}
.device-toggle--inactive {
  background-color: #E0F0F3;
  justify-content: start;
}
.device-toggle__content {
  width: 28px;
  aspect-ratio: 1/1;
  border: none;
  border-radius: 15px;
  margin: 2px;
}
.device-toggle--active .device-toggle__content {
  align-self: center;
  align-items: flex-end;
  background-color: #00666F;
}
.device-toggle--inactive .device-toggle__content {
  align-self: center;
  background-color: #1DADB5;
}

.doc2u-toggle {
  display: flex;
  flex-direction: row;
  align-content: space-between;
  width: 100%;
  height: 58px;
  box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.25);
  border-radius: 15px;
  padding: 5px 10px 5px 10px;
}
.doc2u-toggle .device-toggle--inactive {
  box-shadow: inset 0 4px 8px rgba(0, 0, 0, 0.3);
  background: #eee;
}
.doc2u-toggle__title {
  width: 33%;
  align-self: center;
  font-size: 16px;
  font-weight: 600;
}

@media (max-width: 575px) {
  .test-device .settings__subtitle {
    background: #D3F1F2;
    padding: 0.25rem 0px;
    border-radius: 1rem 1rem 0px 0px;
    margin-bottom: 0px;
  }
  .test-device .device-selector {
    padding: 1rem;
    border-radius: 0px 0px 1rem 1rem;
    border: 1px solid #EEE7E1;
    border-top-width: 0px;
  }
  .test-device .device-selector .device-selector__label {
    text-align: center;
  }
  .test-device .test-device__col {
    order: 3;
  }
  .test-device .test-device__col:nth-child(1) {
    order: 4;
  }
}

.device-selector {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 1.25rem;
}
.device-selector .device-selector__label {
  font-size: 0.875rem;
  font-weight: 600;
  display: block;
  margin-bottom: 0.25rem;
  width: 100%;
}
.device-selector .device-selector__input {
  width: 100%;
  font-size: 0.875rem;
  font-weight: 500;
  border: 1px solid #00666F;
  padding: 0.5rem 2rem 0.5rem 0.625rem;
  border-radius: 1rem;
  color: #00666F;
  outline: none;
  box-shadow: none;
}
.device-selector .device-selector__container {
  position: relative;
}
.device-selector .device-selector__container .device-selector__input {
  appearance: none;
  background: transparent;
}
.device-selector .device-selector__container:after {
  content: "\\e908";
  font-family: "icomoon" !important;
  position: absolute;
  top: 0;
  right: 0;
  font-size: 0.875rem;
  font-weight: 800;
  padding: 0.8rem 0.625rem;
  z-index: -1;
}
.device-selector .device-selector__disable {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  flex: 0 0 2.25rem;
  margin-left: 1.25rem;
  border-radius: 1.125rem;
  border: none;
  outline: none;
  box-shadow: none;
  background: #1DADB5;
  color: #FDFBFB;
  text-align: center;
  font-size: 1rem;
}
.device-selector .device-selector__disable.device-selector__disable--disabled {
  background: #FF4958;
}
.device-selector .device-selector__prefix {
  font-size: 1.5rem;
  margin-right: 0.5rem;
}
.device-selector.device-selector--iconed .device-selector__container {
  width: calc(100% - 3.5rem);
}
.device-selector.device-selector--prefixed .device-selector__label {
  padding-left: 2rem;
}
.device-selector.device-selector--prefixed .device-selector__container {
  width: calc(100% - 2rem);
}
.device-selector.device-selector--prefixed.device-selector--iconed .device-selector__container {
  width: calc(100% - 5.5rem);
}

.cam-box .cam-box-content img {
  max-width: 100%;
  height: auto;
}

.device-workflow .device-workflow__actions {
  text-align: center;
  margin: 1rem 0px;
}
.device-workflow .refuse__title {
  text-align: center;
  font-size: 1.125rem;
  margin: 0px auto 1rem;
}
.device-workflow .refuse__list li {
  margin-bottom: 1rem;
}
.device-workflow .refuse__list img {
  display: block;
  margin: 0.5rem 0px;
}

.btn__notif {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  width: 1rem;
  height: 1rem;
  font-size: 0.5rem;
  background: #FF4958;
  color: #FDFBFB;
  position: absolute;
  top: 0.375rem;
  right: 0.375rem;
  border-radius: 50%;
  font-weight: 900;
}

.settings-video .settings__subtitle,
.settings-audio .settings__subtitle,
.settings-support .settings__subtitle {
  font-size: 1.125rem;
  margin-bottom: 0.625rem;
}
@media (max-width: 575px) {
  .settings-video .device-selector-wrapper,
  .settings-audio .device-selector-wrapper,
  .settings-support .device-selector-wrapper {
    padding: 0.75rem;
    border: 1px solid #EEE7E1;
    border-radius: 1rem;
    width: calc(100% - 2rem);
    margin: 1rem;
  }
}

.settings-support {
  max-width: 31.5rem;
  margin: 0px auto;
  text-align: center;
  font-size: 0.875rem;
}
.settings-support .settings__block {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
}
.settings-support p {
  margin: 0px 0px 0.875rem;
}
.settings-support .settings-support__submitwrap {
  margin-bottom: auto;
}
.settings-support .settings-support__submit {
  font-size: 0.75rem;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.settings-support .settings-support__info {
  max-width: 22rem;
  margin: 3rem auto 0rem;
  font-size: 0.75rem;
  padding: 0.625rem;
  border: 1px solid #1DADB5;
  border-radius: 1rem;
}
@media (max-width: 575px) {
  .settings-support,
  .settings-support .settings__block {
    height: 100%;
  }
  .settings-support .settings-support__info {
    margin-top: auto;
    margin-bottom: 0;
  }
}

.settings-audio .test-device__row {
  align-items: center;
}
.settings-audio .settings__block {
  max-width: 17rem;
  margin-left: auto;
  margin-right: auto;
}
@media (max-width: 575px) {
  .settings-audio .settings__block {
    max-width: 100%;
  }
}
.settings-audio .settings__block--audiometer,
.settings-audio .settings__block--audiooutput {
  min-height: 3.75rem;
  margin-bottom: 1.125rem;
}
@media (max-width: 575px) {
  .settings-audio .settings__block--audiometer,
  .settings-audio .settings__block--audiooutput {
    margin-bottom: 0.25rem;
    min-height: auto;
  }
}
.settings-audio .settings__block--audiometer {
  padding-top: 0.875rem;
  max-width: 14rem;
  margin-left: auto;
  margin-right: auto;
}
.settings-audio .settings__block--audiometer label {
  display: block;
  margin-bottom: 0.5rem;
}
.settings-audio .settings__block--audiooutput {
  max-width: 14rem;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
}
.settings-audio .settings__block--audiooutput i {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 50%;
  background: #1DADB5;
  color: #FDFBFB;
  font-size: 1.375rem;
  margin-left: 0.5rem;
  flex-grow: 0;
  flex-shrink: 0;
}
.settings-audio .settings-audio__volume {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}
.settings-audio .settings-audio__volume .range {
  flex: 0 1 17.75rem;
}
.settings-audio .settings-audio__volume i {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 50%;
  background: #1DADB5;
  color: #FDFBFB;
  font-size: 1.375rem;
  flex-grow: 0;
  flex-shrink: 0;
  cursor: pointer;
}
.settings-audio .settings-audio__volume i:first-child {
  margin-right: 0.5rem;
}
.settings-audio .settings-audio__volume i:last-child {
  margin-left: 0.5rem;
}
@media (max-width: 575px) {
  .settings-audio .settings-audio__volume .range__input {
    height: 0.375rem;
    border-radius: 0.375rem;
  }
  .settings-audio .settings-audio__volume .range__input::-webkit-slider-thumb {
    height: 0.875rem;
    width: 0.875rem;
    border-width: 1px;
  }
}

.settings-video .test-device__col:first-child {
  flex: 0 0 62%;
  width: 62%;
}
.settings-video .test-device__col:last-child {
  flex: 0 0 38%;
  width: 38%;
}
@media (max-width: 575px) {
  .settings-video .test-device__col {
    order: 2;
  }
  .settings-video .test-device__col, .settings-video .test-device__col:first-child, .settings-video .test-device__col:last-child {
    flex: 0 0 100%;
    width: 100%;
  }
  .settings-video .test-device__col:first-child {
    order: 3;
  }
}

/*
body:not(.onetoone-type-extern) {
  video:not(.screen-video):not([data-sessionrole="extern"]) {
    transform: rotateY(180deg);
    -webkit-transform: rotateY(180deg);
    // Safari and Chrome
    -moz-transform: rotateY(180deg);
    // Firefox 
  }
}*/
#webcam-preview {
  transform: rotateY(180deg);
  -webkit-transform: rotateY(180deg);
  -moz-transform: rotateY(180deg);
}

.onetoone-type-extern #webcam-preview {
  transform: inherit;
  -webkit-transform: inherit;
  -moz-transform: inherit;
}

body .lightbox-media video {
  transform: inherit !important;
  -webkit-transform: inherit !important;
  /* Safari and Chrome */
  -moz-transform: inherit !important;
  /* Firefox */
}

@media (max-width: 767px), (max-height: 575px) {
  .test-device__col:first-child, .test-device__col:last-child {
    flex: 0 0 100%;
    width: 100%;
  }
}
.hoco_title {
  font-size: 1.25rem;
  line-height: 1.3;
  margin: 0px auto 0.625rem;
  text-align: center;
  max-width: 32rem;
  font-family: inherit;
  font-weight: 600;
}

.hoco_subtitle {
  text-align: center;
  max-width: 32rem;
  margin: 0.625rem auto 4rem;
  font-family: inherit;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/styles/index.scss","webpack://./src/styles/_normalize.scss","webpack://./src/styles/_icomoon.scss","webpack://./src/styles/_fonts.scss","webpack://./src/styles/_picto.scss","webpack://./src/styles/_button.scss","webpack://./src/styles/abstracts/_variables.scss","webpack://./src/styles/_utilities.scss","webpack://./src/styles/abstracts/_functions.scss","webpack://./src/styles/_form.scss"],"names":[],"mappings":"AAAA,gBAAgB;AC4ChB;;;;;;;;;;;EAWC,cAAA;AD1CD;;AC+CA;;;EAGC,qBAAA;AD5CD;;ACsDA;EACC,aAAA;EACA,SAAA;ADnDD;;AC2DA;EACC,aAAA;ADxDD;;ACoEA;EAIE,gBAjEW;EAkEX,WAjEM;EAkEP,8BAAA;EACA,0BAAA;ADpED;;ACyEA;;;;;EAKC,uBAhGwB;AD0BzB;;AC2EA;EACC,SAAA;ADxED;;ACoFA;EAGC,uBAAA;ADnFD;ACuFC;EACC,oBAAA;ADrFF;AC0FC;EAEC,UAAA;ADzFF;;ACqGC;EACC,cA1Ia;EA2Ib,gBApIU;ADkCZ;;ACqGC;EACC,gBA9Ia;EA+Ib,gBAxIU;ADsCZ;;ACqGC;EACC,iBAlJa;EAmJb,aA5IU;AD0CZ;;ACqGC;EACC,cAtJa;EAuJb,gBAhJU;AD8CZ;;ACqGC;EACC,iBA1Ja;EA2Jb,gBApJU;ADkDZ;;ACqGC;EACC,iBA9Ja;EA+Jb,gBAxJU;ADsDZ;;ACwGA;EACC,yBAAA;ADrGD;;AC0GA;;EAEC,iBAAA;ADvGD;;ACkHA;EACC,kBAAA;AD/GD;;ACoHA;EACC,gBAAA;EACA,WAAA;ADjHD;;AC+HA;;;;EAIC,6BAAA;EAIA,cAAA;AD/HD;;ACoIA;EACC,gBAAA;EACA,qBAAA;EACA,qBAAA;ADjID;;ACsIA;EACC,uBAAA;ADnID;;ACkJC;EAEC,WAAA;EACA,aAAA;ADhJF;;ACsJA;EACC,cAAA;ADnJD;;ACyJA;;EAEC,cAAA;EACA,cAAA;EACA,kBAAA;EACA,wBAAA;ADtJD;;ACyJA;EACC,WAAA;ADtJD;;ACyJA;EACC,eAAA;ADtJD;;ACyMA;EACC,SAAA;ADtMD;;AC8MA;EACC,gBAAA;AD3MD;;ACoNA;EACC,SAAA;ADjND;;ACiOA;EACC,yBAAA;EACA,aAAA;EACA,8BAAA;AD9ND;;ACsOA;EACC,SAAA;EACA,UAAA;EACA,mBAAA;ADnOD;;AC8OA;;;;EAIC,oBAAA;EACA,eAAA;EACA,SAAA;EACA,wBAAA;AD3OD;;ACmPA;EACC,mBAAA;ADhPD;;ACwPA;;EAEC,oBAAA;ADrPD;;ACgQA;;;;EAIC,0BAAA;EACA,eAAA;AD7PD;;ACqQA;;EAEC,eAAA;ADlQD;;ACyQC;EACC,SAAA;EACA,UAAA;ADtQF;;AC6QA;EACC,cAAA;EACA,mBAAA;AD1QD;;ACmRA;EACC,yBAAA;EACA,iBAAA;ADhRD;;ACsRC;EACC,6BAAA;EAGA,uBAAA;ADnRF;ACuRE;EAEC,wBAAA;ADtRH;AC8RC;EAEC,sBAAA;EACA,UAAA;AD7RF;;AEpOA;EACE,sBAAA;EACA,8KACE;EAGF,mBAAA;EACA,kBAAA;EACA,mBAAA;AFoOF;AEjOA;;EAEE,+EAAA;EACA,iCAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EAEA,sCAAA;EACA,mCAAA;EACA,kCAAA;AFkOF;;AE9IK;;EACE,gBAAA;AFkJP;;AE7IE;;EAEG,gBAvFG;AFuOR;;AElJE;;EAEG,gBAvFG;AF4OR;;AEvJE;;EAEG,gBAvFG;AFiPR;;AE5JE;;EAEG,gBAvFG;AFsPR;;AEjKE;;EAEG,gBAvFG;AF2PR;;AEtKE;;EAEG,gBAvFG;AFgQR;;AE3KE;;EAEG,gBAvFG;AFqQR;;AEhLE;;EAEG,gBAvFG;AF0QR;;AErLE;;EAEG,gBAvFG;AF+QR;;AE1LE;;EAEG,gBAvFG;AFoRR;;AE/LE;;EAEG,gBAvFG;AFyRR;;AEpME;;EAEG,gBAvFG;AF8RR;;AEzME;;EAEG,gBAvFG;AFmSR;;AE9ME;;EAEG,gBAvFG;AFwSR;;AEnNE;;EAEG,gBAvFG;AF6SR;;AExNE;;EAEG,gBAvFG;AFkTR;;AE7NE;;EAEG,gBAvFG;AFuTR;;AElOE;;EAEG,gBAvFG;AF4TR;;AEvOE;;EAEG,gBAvFG;AFiUR;;AE5OE;;EAEG,gBAvFG;AFsUR;;AEjPE;;EAEG,gBAvFG;AF2UR;;AEtPE;;EAEG,gBAvFG;AFgVR;;AE3PE;;EAEG,gBAvFG;AFqVR;;AEhQE;;EAEG,gBAvFG;AF0VR;;AErQE;;EAEG,gBAvFG;AF+VR;;AE1QE;;EAEG,gBAvFG;AFoWR;;AE/QE;;EAEG,gBAvFG;AFyWR;;AEpRE;;EAEG,gBAvFG;AF8WR;;AEzRE;;EAEG,gBAvFG;AFmXR;;AE9RE;;EAEG,gBAvFG;AFwXR;;AEnSE;;EAEG,gBAvFG;AF6XR;;AExSE;;EAEG,gBAvFG;AFkYR;;AE7SE;;EAEG,gBAvFG;AFuYR;;AElTE;;EAEG,gBAvFG;AF4YR;;AEvTE;;EAEG,gBAvFG;AFiZR;;AE5TE;;EAEG,gBAvFG;AFsZR;;AEjUE;;EAEG,gBAvFG;AF2ZR;;AEtUE;;EAEG,gBAvFG;AFgaR;;AE3UE;;EAEG,gBAvFG;AFqaR;;AEhVE;;EAEG,gBAvFG;AF0aR;;AErVE;;EAEG,gBAvFG;AF+aR;;AE1VE;;EAEG,gBAvFG;AFobR;;AE/VE;;EAEG,gBAvFG;AFybR;;AEpWE;;EAEG,gBAvFG;AF8bR;;AEzWE;;EAEG,gBAvFG;AFmcR;;AE9WE;;EAEG,gBAvFG;AFwcR;;AEnXE;;EAEG,gBAvFG;AF6cR;;AExXE;;EAEG,gBAvFG;AFkdR;;AE7XE;;EAEG,gBAvFG;AFudR;;AElYE;;EAEG,gBAvFG;AF4dR;;AEvYE;;EAEG,gBAvFG;AFieR;;AE5YE;;EAEG,gBAvFG;AFseR;;AEjZE;;EAEG,gBAvFG;AF2eR;;AEtZE;;EAEG,gBAvFG;AFgfR;;AE3ZE;;EAEG,gBAvFG;AFqfR;;AEhaE;;EAEG,gBAvFG;AF0fR;;AEraE;;EAEG,gBAvFG;AF+fR;;AE1aE;;EAEG,gBAvFG;AFogBR;;AE/aE;;EAEG,gBAvFG;AFygBR;;AEpbE;;EAEG,gBAvFG;AF8gBR;;AEzbE;;EAEG,gBAvFG;AFmhBR;;AE9bE;;EAEG,gBAvFG;AFwhBR;;AEncE;;EAEG,gBAvFG;AF6hBR;;AExcE;;EAEG,gBAvFG;AFkiBR;;AE7cE;;EAEG,gBAvFG;AFuiBR;;AEldE;;EAEG,gBAvFG;AF4iBR;;AEvdE;;EAEG,gBAvFG;AFijBR;;AE5dE;;EAEG,gBAvFG;AFsjBR;;AEjeE;;EAEG,gBAvFG;AF2jBR;;AEteE;;EAEG,gBAvFG;AFgkBR;;AE3eE;;EAEG,gBAvFG;AFqkBR;;AEhfE;;EAEG,gBAvFG;AF0kBR;;AGzmBA;EACE,yBAAA;EACA,4CAAA;EACA,qPAAA;EAIA,iBAAA;EACA,kBAAA;EACA,kBAAA;AHymBF;AGtmBA;EACE,yBAAA;EACA,4CAAA;EACA,wPAAA;EAIA,gBAAA;EACA,kBAAA;EACA,kBAAA;AHqmBF;AGlmBA;EACE,yBAAA;EACA,6CAAA;EACA,yPAAA;EAIA,mBAAA;EACA,kBAAA;EACA,kBAAA;AHimBF;AG9lBA;EACE,yBAAA;EACA,6CAAA;EACA,yPAAA;EAIA,gBAAA;EACA,kBAAA;EACA,kBAAA;AH6lBF;AG1lBA;EACE,oBAAA;EACA,6CAAA;EACA,yPAAA;EAIA,gBAAA;EACA,kBAAA;EACA,kBAAA;AHylBF;AGtlBA;EACE,oBAAA;EACA,6CAAA;EACA,yPAAA;EAIA,iBAAA;EACA,kBAAA;EACA,kBAAA;AHqlBF;AGllBA;EACE,oBAAA;EACA,6CAAA;EACA,yPAAA;EAIA,mBAAA;EACA,kBAAA;EACA,kBAAA;AHilBF;AI1pBA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,wBAAA;EACA,2BAAA;AJ4pBF;;AIxpBE;EACE,0DAAA;AJ2pBJ;;AI5pBE;EACE,0DAAA;AJ+pBJ;;AIhqBE;EACE,0DAAA;AJmqBJ;;AIpqBE;EACE,0DAAA;AJuqBJ;;AIxqBE;EACE,0DAAA;AJ2qBJ;;AI5qBE;EACE,0DAAA;AJ+qBJ;;AKlsBA;EACI,qBAAA;EACA,gBAAA;EAEA,8BC8BY;ED7Bf,gBAAA;EACA,kBAAA;EACA,sBAAA;EACG,gBAAA;EACA,mBAAA;EACA,iBAAA;EACH;;uBAAA;EAGA,eAAA;EACG,mBCTW;EDUd,6BAAA;EACG,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,cCXW;EDYX,2BAAA;ALosBJ;AKlsBI;EACI,gCCcW;EDbX,gBAAA;EACA,qBAAA;EACA,eAAA;ALosBR;AKhsBC;EAEO,cCxBO;EDyBb,qBAAA;ALisBF;AK7rBC;EAEC,aAAA;EACM,gBAAA;AL8rBR;AK1rBC;EAEC,mBAAA;EACM,aAAA;AL2rBR;;AKtrBI;EACI,cChDO;EDiDP,mBC5BQ;ED6BR,qBC7BQ;ANstBhB;AKvrBQ;EAEI,cCtDG;EDuDH,8DAAA;EACA,gEAAA;ALwrBZ;AKprBY;EACI,mBAAA;EACA,qBAAA;ALsrBhB;AKprBgB;EAEI,8DAAA;EACA,gEAAA;ALqrBpB;AKhrBQ;EACI,mBCzEG;ED0EH,cCrDI;ANuuBhB;AKhrBY;EAEI,mBC9ED;ED+EC,yDAAA;ALirBhB;AK7qBgB;EACI,iBAAA;EACA,qBC3EE;ED4EF,cC5EE;AN2vBtB;AK7qBoB;EAEI,yCAAA;EACA,kCAAA;AL8qBxB;;AK1tBI;EACI,cChDO;EDiDP,mBC5BQ;ED6BR,qBC7BQ;AN0vBhB;AK3tBQ;EAEI,cCtDG;EDuDH,iBAAA;EACA,mBAAA;AL4tBZ;AK5sBQ;EACI,mBCzEG;ED0EH,cCrDI;ANmwBhB;AK5sBY;EAEI,mBC9ED;ED+EC,YAAA;AL6sBhB;;AK7uBI;EACI,cChDO;EDiDP,mBC5BQ;ED6BR,qBC7BQ;AN6wBhB;AK9uBQ;EAEI,cCtDG;EDuDH,uCAAA;EACA,yCAAA;AL+uBZ;AK/tBQ;EACI,mBCzEG;ED0EH,cCrDI;ANsxBhB;AK/tBY;EAEI,mBC9ED;ED+EC,kCAAA;ALguBhB;;AKhwBI;EACI,cChDO;EDiDP,mBC5BQ;ED6BR,qBC7BQ;ANgyBhB;AKjwBQ;EAEI,cCtDG;EDuDH,8DAAA;EACA,gEAAA;ALkwBZ;AKlvBQ;EACI,mBCzEG;ED0EH,cCrDI;ANyyBhB;AKlvBY;EAEI,mBC9ED;ED+EC,yDAAA;ALmvBhB;;AOn0BA;EACI,cAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;APs0BJ;AOh0BI;EACI,yBAAA;EACA,mBDZO;ECaP,eAAA;EACA,uBAAA;EACA,kBAAA;APk0BR;AO/zBI;EACI,mBDXS;ECYT,YAAA;EACA,WAAA;EACA,kCAAA;EACA,sBAAA;APi0BR;AO9zBI;EACI,kBAAA;APg0BR;AO/zBQ;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,iBAAA;EACA,cDlCG;ECmCH,UAAA;APi0BZ;AO7zBI;EACI,cDxCO;ANu2Bf;AO9zBQ;EACI,qBD1CG;EC2CH,mBDnCK;ANm2BjB;AO9zBQ;EACI,mBD9CG;AN82Bf;AO5zBQ;EACI,cD3CK;ANy2BjB;;AOpzBI;EACI,WAAA;EACA,wBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBDnEO;ECoEP,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mDAAA;EACA,4BAAA;APuzBR;AOrzBQ;EACI,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBD/EG;ECgFH,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,oBAAA;EACA,kBAAA;APuzBZ;AOpzBQ;EACI,wBAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;APszBZ;AOnzBI;EACI,eAAA;EACA,YAAA;APqzBR;AOpzBQ;EAEI,0BAAA;APqzBZ;AOnzBQ;EACI,0BAAA;EACA,YAAA;APqzBZ;;AOhzBA;EACI,aAAA;EACA,iBAAA;EACA,mBAAA;APmzBJ;AOlzBI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBDtHO;ECuHP,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;APozBR;AOnzBQ;EACI,cAAA;EACA,eAAA;APqzBZ;AOlzBI;EACI,cAAA;APozBR;AOjzBI;EACI,sBAAA;APmzBR;AOlzBQ;EACI,iBAAA;EACA,uBAAA;APozBZ;AOlzBQ;EACI,yBAAA;EACA,mBAAA;EACA,gBAAA;APozBZ;;AO1yBA;EACI,aAAA;AP6yBJ;;AO3yBA;EACI,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,2BAAA;EACA,wBAAA;AP8yBJ;AO7yBI;EACI,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBD3KO;EC4KP,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,cDvKc;ANs9BtB;AO7yBQ;EACI,cDnLC;ECoLD,qBDpLC;ANm+Bb;AO3yBI;EACI,YAAA;AP6yBR;AO5yBQ;;EAEI,yBAAA;UAAA,iBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,oCAAA;EACA,cD9LK;EC+LL,sBAAA;EACA,iBAAA;EACA,eAAA;AP8yBZ;AO5yBQ;EACI,YAAA;AP8yBZ;AO5yBQ;EACI,WAAA;EACA,SAAA;EACA,yBAAA;AP8yBZ;AQl9BE;ED4IE;IA2BQ,WAAA;EP+yBV;AACF;;AOtyBA;EACI,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;APyyBJ;AOvyBI;EACI,gBAAA;APyyBR;AOvyBI;EACI,YAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;APyyBR;AOpyBI;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,cDxPO;ECyPP,aAAA;EACA,mBAAA;EACA,uBAAA;APsyBR;AOpyBI;EACI,eAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,+CAAA;EACA,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,cDvPS;ECwPT,eAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,UAAA;EACA,2BAAA;EACA,yBAAA;EACA,mBAAA;APqyBR;AOpyBQ;EACI,mBDpRG;AN0jCf;AOlyBI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;APoyBR;AOhyBQ;EACI,aAAA;APkyBZ;AO9xBI;EACI,kBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;APgyBR;AO9xBQ;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;APgyBZ;AO5xBI;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,cD9TO;EC+TP,eAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AP8xBR;AQ5hCE;EDiQM;IACI,cAAA;IACA,eAAA;IACA,kBAAA;EP8xBV;AACF;;AOpxBA;EACI,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,cD5VS;EC6VT,kBAAA;EACA,gBAAA;EACA,qBAAA;APuxBJ;AOrxBI;EACI,iBAAA;EACA,oBAAA;APuxBR;;AO7wBA;EACE,WAAA;EACA,cAAA;EACA,yBAAA;EACA,mBDlXa;ECmXb,sBAAA;EACA,gBAAA;APgxBF;AO/wBE;EACE,YAAA;EACA,mBD/Wa;ECgXb,6BAAA;APixBJ;AO9wBE;EACE,aAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;APgxBJ;AO/wBI;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;APixBN;;AOxwBA;EACI;IACI,yBAAA;EP2wBN;AACF;AOzwBA;EACI,eAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AP2wBJ;AOzwBI;EACI,mBD/ZO;ECgaP,cAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AP2wBR;AOxwBI;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,8BAAA;EACA,gCAAA;EACA,6BAAA;EACA,yCAAA;AP0wBR;;AO/vBA;EACI,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,uBAAA;EACA,kBAAA;APkwBJ;AOjwBI;EACI,WAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;APmwBR;AOjwBI;EACI,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBDndO;ECodP,gCAAA;EACA,0BAAA;EACA,0CAAA;EACA,eAAA;EACA,oCAAA;APmwBR;AOlwBQ;EACI,4BDxdI;AN4tChB;AOlwBQ;EACI,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;APowBZ;AOlwBQ;EACI,oBAAA;APowBZ;AOlwBQ;EACI,qBAAA;APowBZ;AQtrCE;EDsYF;IAgDQ,iBAAA;IACA,eAAA;IACA,WAAA;IACA,oBAAA;EPowBN;EOnwBM;IACI,QAAA;IACA,YAAA;IACA,cAAA;IACA,eAAA;IACA,WAAA;IACA,2CAAA;EPqwBV;EOnwBM;IACI,wBAAA;IACA,kBAAA;IACA,gBAAA;IACA,mBAAA;IACA,cAAA;EPqwBV;EOpwBU;IACI,sBAAA;EPswBd;AACF;;AOlwBA;EACI,wBAAA;APqwBJ;;AQptCE;EDidF;IAEQ,aAAA;IACA,sBAAA;EPswBN;EOrwBM;IACI,gBAAA;IACA,QAAA;IACA,cAAA;EPuwBV;EOrwBM;IACI,QAAA;IACA,cAAA;IACA,gBAAA;IACA,gBAAA;EPuwBV;AACF;;AOnwBA;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,aAAA;EACA,cAAA;EACA,yBAAA;EACA,cD/hBW;ECgiBX,oCAAA;EACA,kBAAA;EACA,+CAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;APswBJ;AOrwBI;EACI,oCAAA;APuwBR;AOpwBI;EACI,mBD1iBQ;EC2iBR,qBD3iBQ;ANizChB;AOrwBQ;EACI,8DAAA;EACA,gEAAA;APuwBZ;AQnwCE;EDmeF;IA6BQ,aAAA;EPuwBN;AACF;;AS9zCA;EACE,wBAAA;ATi0CF;ASh0CE;EACE,qCH8BY;EG7BZ,gBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;ATk0CJ;AS/zCE;EACE,mBAAA;EACA,iBAAA;EACA,yBAAA;ATi0CJ;;ASzzCA;EACE,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;AT4zCF;;AS1zCA;EACE,aAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;EACA,oCAAA;AT6zCF;AS5zCE;EACE,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;AT8zCJ;AS5zCE;EACE,kBAAA;EACA,cH1CY;EG2CZ,qBAAA;AT8zCJ;AS5zCE;EACE,gBAAA;EACA,cAAA;AT8zCJ;AS5zCE;EAEE,eAAA;EACA,kBAAA;EACA,mBAAA;AT6zCJ;AS3zCE;EACE,qBAAA;AT6zCJ;;ASxzCA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;AT2zCF;ASzzCE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;AT2zCJ;;AStzCA;EACE,WAAA;EACA,gBAAA;EACA,sBAAA;ATyzCF;ASvzCE;EACE,qBAAA;ATyzCJ;AStzCE;EACE,gBAAA;ATwzCJ;ASrzCE;EACE,gBAAA;ATuzCJ;ASrzCE;EAIE,eAAA;EACA,cAAA;ATozCJ;ASlzCE;EACE,eAAA;EACA,cAAA;ATozCJ;ASlzCI;EACE,cAAA;ATozCN;AShzCE;EACE,cAAA;EACA,gCHlFe;EGmFf,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;ATkzCJ;AShzCI;EACE,sBAAA;ATkzCN;AS/yCI;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;ATizCN;AS7yCE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,qDAAA;EACA,gCH1Ge;EG2Gf,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cHpIkB;EGqIlB,YAAA;EACA,aAAA;AT+yCJ;AS7yCI;EACE,cHzIgB;ANw7CtB;AS3yCE;EACE,qDAAA;EACA,4BAAA;AT6yCJ;AS1yCE;EACE,WAAA;EACA,yBAAA;EACA,qDAAA;EACA,qBAAA;EACA,mBHjKW;EGkKX,aAAA;EACA,gBAAA;AT4yCJ;ASzyCE;EACE,uBAAA;AT2yCJ;ASxyCE;EACE,kBAAA;AT0yCJ;ASvyCE;EACE,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,sBAAA;EACA,qBAAA;EACA,gCHpJe;EGqJf,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,cH9KkB;ANu9CtB;;AAh+CA;EACE,sBAAA;AAm+CF;;AAh+CA;EACE,eM4BW;ANu8Cb;;AAh+CA;EACE,SAAA;EACA,8BMiBc;ENhBd,kBAAA;EACA,mCAAA;EACA,kCAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AAm+CF;AAl+CE;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;AAo+CJ;;AAh+CA;;;;;;;;;;;;EAYE,8BMTc;AN4+ChB;;AAh+CA;EACE,+EAAA;AAm+CF;;AA/9CA;EACE,UAAA;EACA,eAAA;AAk+CF;;AA/9CA;EACE,mBM/CW;ANihDb;;AA/9CA;EACE,mBMlDe;ANohDjB;;AA/9CA;EACE,kBAAA;EACA,YAAA;EAoBA,cMhFa;ENiFb,mBMzEe;ANwhDjB;AAl+CE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAo+CJ;AAj+CE;EACE,aAAA;EACA,cAAA;EACA,mBAAA;AAm+CJ;AAh+CE;EACE,gBAAA;EACA,iBAAA;EACA,sBAAA;AAk+CJ;AA59CE;EACE,mBMpFW;ENqFX,cM7Ea;AN2iDjB;;AAr9CA;EACE,cMrFoB;AN6iDtB;AAt9CE;EACE,kBAAA;EACA,sBAAA;AAw9CJ;AAr9CE;EACE,mBAAA;EACA,gBAAA;EACA,yBAAA;AAu9CJ;AAp9CE;EACE,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAs9CJ;AAn9CE;EACE,gBAAA;EACA,kBAAA;AAq9CJ;AAj9CE;EACE,mBAAA;EACA,cAAA;EACA,WAAA;EACA,wDAAA;EACA,mBAAA;AAm9CJ;AAh9CE;EACE,cAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AAk9CJ;AA/8CE;EACE,kBAAA;EACA,kBAAA;AAi9CJ;AA/8CI;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,aAAA;EACA,cAAA;EACA,6BAAA;AAi9CN;AA98CI;EACE,kBAAA;EACA,cAAA;EACA,sBAAA;EAaA,kCAAA;EAaA,8BAAA;AAw7CN;AAh9CM;EACE,WAAA;EACA,YAAA;EACA,qBMtJc;ANwmDtB;AA/8CM;EACE,uCAAA;EACA,aAAA;AAi9CR;AA78CM;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;AA+8CR;AA38CM;EACE,YAAA;EACA,+CAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cM1LQ;ANuoDhB;AAx8CI;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,cMnMU;AN6oDhB;AAv8CI;EACE,eAAA;EACA,gBAAA;EACA,eAAA;AAy8CN;AQhmDE;ERyJM;IACE,cAAA;IACA,WAAA;IACA,gBAAA;IACA,uBAAA;IACA,mBAAA;EA08CR;AACF;AAt8CI;EACE,WAAA;EACA,qBAAA;AAw8CN;AAr8CI;EACE,qBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,wBAAA;AAu8CN;AAr8CM;EACE,cM5NS;ANmqDjB;AAp8CM;EACE,cMvOK;AN6qDb;AAn8CM;EACE,WAAA;EACA,qBAAA;AAq8CR;AAh8CE;EACE,mBAAA;EACA,yBAAA;EACA,sBAAA;AAk8CJ;AA77CE;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;AA+7CJ;AA77CI;EACE,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EAMA;;;;;;;IAAA;AAi8CN;AAr8CM;EACE,qBAAA;AAu8CR;;AAn7CA;EACE,kBAAA;EACA,oBAAA;EACA,gBAAA;AAs7CF;AAp7CE;EACE,gBAAA;EACA,mBAAA;EACA,qBAAA;AAs7CJ;AAn7CE;EACE,mBAAA;EACA,yBAAA;AAq7CJ;;AA16CE;;;;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;AAg7CJ;AA76CE;;;;EACE,mBAAA;EACA,yBAAA;AAk7CJ;AA/6CE;;;;EACE,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,WAAA;AAo7CJ;AAj7CE;;;;EACE,eAAA;EACA,aAAA;EACA,UAAA;AAs7CJ;AAn7CE;;;;;;;;EAEE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;AA27CJ;AAx7CE;;;;EACE,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;AA67CJ;AA17CE;;;;EACE,kBAAA;AA+7CJ;AA17CI;;;;EACE,gBAAA;EACA,aAAA;AA+7CN;AQvvDE;ER8TE;;;;IACE,eAAA;EA+7CJ;EA57CE;;;;IACE,iBAAA;IACA,kBAAA;IACA,cAAA;IACA,WAAA;EAi8CJ;EA77CI;;;;IACE,cAAA;IACA,WAAA;EAk8CN;AACF;AQxwDE;ER2UE;;;;IACE,wBAAA;EAm8CJ;AACF;;AA57CA;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;AA+7CF;AA77CE;EACE,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AA+7CJ;AA57CE;EACE,mBAAA;EACA,gCM5Xe;EN6Xf,gBAAA;AA87CJ;AA37CE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cMjaa;ENkab,mBAAA;EACA,iBAAA;AA67CJ;AA37CI;EACE,cM7aO;EN8aP,qBM9aO;AN22Db;AA17CI;EACE,cMjbU;ENkbV,qBMlbU;AN82DhB;AA17CM;EACE,eAAA;AA47CR;AAv7CE;EACE,oBAAA;EACA,WAAA;AAy7CJ;AQ10DE;ERqZE;IACE,oBAAA;IACA,WAAA;EAw7CJ;EAt7CE;IACE,WAAA;IACA,YAAA;EAw7CJ;EAv7CI;IACE,WAAA;EAy7CN;AACF;;AA/6CA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AAk7CF;AAh7CE;EACE,yBMtda;ENudb,oBAAA;AAk7CJ;AA/6CE;EACE,yBAAA;EACA,sBAAA;AAi7CJ;AA96CE;EACE,WAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;AAg7CJ;AA96CI;EACE,kBAAA;EACA,qBAAA;EACA,yBMvegB;ANu5DtB;AA76CI;EACE,kBAAA;EACA,yBM9eW;AN65DjB;;AAt6CA;EACE,aAAA;EACA,mBAAA;EACA,4BAAA;EACA,WAAA;EACA,YAAA;EACA,+CAAA;EACA,mBAAA;EACA,0BAAA;AAy6CF;AAx6CE;EACE,8CAAA;EACA,gBAAA;AA06CJ;AAv6CE;EACE,UAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAy6CJ;;AQt4DE;ERseE;IACE,mBMhhBiB;INihBjB,oBAAA;IACA,gCAAA;IACA,kBAAA;EAo6CJ;EAj6CE;IACE,aAAA;IACA,gCAAA;IACA,yBAAA;IACA,qBAAA;EAm6CJ;EAj6CI;IACE,kBAAA;EAm6CN;EA/5CE;IACE,QAAA;EAi6CJ;EA/5CI;IACE,QAAA;EAi6CN;AACF;;AA15CA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;AA65CF;AA35CE;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,WAAA;AA65CJ;AA15CE;EACE,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,oCAAA;EACA,mBAAA;EACA,cMnkBkB;ENokBlB,aAAA;EACA,gBAAA;AA45CJ;AAr5CE;EACE,kBAAA;AAu5CJ;AAr5CI;EAGE,gBAAA;EACA,uBAAA;AAu5CN;AAp5CI;EACE,gBAAA;EACA,iCAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;EACA,wBAAA;EACA,WAAA;AAs5CN;AAl5CE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,mBMjnBa;ENknBb,cM1nBW;EN2nBX,kBAAA;EACA,eAAA;AAo5CJ;AAl5CI;EACE,mBM9nBO;ANkhEb;AA/4CE;EACE,iBAAA;EACA,oBAAA;AAi5CJ;AA74CI;EACE,0BAAA;AA+4CN;AA14CI;EACE,kBAAA;AA44CN;AAz4CI;EACE,wBAAA;AA24CN;AAv4CM;EACE,0BAAA;AAy4CR;;AAh4CI;EACE,eAAA;EACA,YAAA;AAm4CN;;AA73CE;EACE,kBAAA;EACA,gBAAA;AAg4CJ;AA73CE;EACE,kBAAA;EACA,mBAAA;EACA,qBAAA;AA+3CJ;AA33CI;EACE,mBAAA;AA63CN;AA13CI;EACE,cAAA;EACA,kBAAA;AA43CN;;AAv3CA;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBMzsBW;EN0sBX,cM3sBa;EN4sBb,kBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AA03CF;;AA92CE;;;EACE,mBAAA;EACA,uBAAA;AAm3CJ;AQ7hEE;ER+qBE;;;IACE,gBAAA;IACA,yBAAA;IACA,mBAAA;IACA,wBAAA;IACA,YAAA;EAm3CJ;AACF;;AA92CA;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAi3CF;AA/2CE;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;AAi3CJ;AA92CE;EACE,wBAAA;AAg3CJ;AA72CE;EACE,mBAAA;AA+2CJ;AA52CE;EACE,kBAAA;EACA,qBAAA;EACA,wBAAA;AA82CJ;AA32CE;EACE,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;AA62CJ;AQvkEE;ER+tBE;;IAEE,YAAA;EA22CJ;EAx2CE;IACE,gBAAA;IACA,gBAAA;EA02CJ;AACF;;AAr2CE;EACE,mBAAA;AAw2CJ;AAr2CE;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;AAu2CJ;AQ1lEE;ERgvBA;IAMI,eAAA;EAw2CJ;AACF;AAr2CE;;EAEE,mBAAA;EACA,uBAAA;AAu2CJ;AQpmEE;ER0vBA;;IAMI,sBAAA;IACA,gBAAA;EAy2CJ;AACF;AAt2CE;EACE,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAw2CJ;AAt2CI;EACE,cAAA;EACA,qBAAA;AAw2CN;AAp2CE;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAs2CJ;AAp2CI;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBM30BW;EN40BX,cMp1BS;ENq1BT,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;AAs2CN;AAl2CE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AAo2CJ;AAl2CI;EACE,kBAAA;AAo2CN;AAj2CI;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBMp2BW;ENq2BX,cM72BS;EN82BT,mBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AAm2CN;AAj2CM;EACE,oBAAA;AAm2CR;AAh2CM;EACE,mBAAA;AAk2CR;AQtqEE;ER40BM;IACE,gBAAA;IACA,uBAAA;EA61CR;EAz1CQ;IACE,gBAAA;IACA,eAAA;IACA,iBAAA;EA21CV;AACF;;AAl1CI;EACE,aAAA;EACA,UAAA;AAq1CN;AAl1CI;EACE,aAAA;EACA,UAAA;AAo1CN;AQ1rEE;ER22BE;IACE,QAAA;EAk1CJ;EAh1CI;IAGE,cAAA;IACA,WAAA;EAg1CN;EA70CI;IACE,QAAA;EA+0CN;AACF;;AA10CA;;;;;;;;;EAAA;AAWA;EACE,0BAAA;EACE,kCAAA;EAEA,+BAAA;AA20CJ;;AAv0CA;EACE,kBAAA;EACA,0BAAA;EACA,uBAAA;AA00CF;;AAv0CA;EACE,6BAAA;EACA,qCAAA;EACA,sBAAA;EACA,kCAAA;EACA,YAAA;AA00CF;;AQ3uEE;ERy6BE;IAEE,cAAA;IACA,WAAA;EAq0CJ;AACF;AAj0CA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;AAm0CF;;AAh0CA;EACE,kBAAA;EACA,gBAAA;EACA,0BAAA;EACA,oBAAA;EACA,gBAAA;AAm0CF","sourcesContent":["@use './normalize.scss';\n@use './abstracts/variables' as *;\n@use './abstracts/functions';\n@use './icomoon.scss';\n@use './fonts';\n@use './picto.scss';\n@use './button.scss';\n@use './utilities.scss';\n@use './form.scss';\n\n* {\n  box-sizing: border-box;\n}\n\nhtml {\n  font-size: $size__text;\n}\n\nbody {\n  margin: 0;\n  font-family: $font__text;\n  font-size: inherit;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: fixed;\n  width: 100%;\n  max-height: 100%;\n  &.demo-page {\n    max-height: inherit;\n    position: relative;\n    overflow-y: auto;\n  }\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6 {\n  font-family: $font__title;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n*::-webkit-scrollbar {\n  width: 5px;\n  cursor: pointer;\n}\n\n*::-webkit-scrollbar-track {\n  background: $color_grey;\n}\n\n*::-webkit-scrollbar-thumb {\n  background: $color-darkgrey;\n}\n\n.btn-icon {\n  border-radius: 50%;\n  border: none;\n\n  &.btn-size1 {\n    width: 1rem;\n    height: 1rem;\n    line-height: 1rem;\n  }\n\n  &.btn-size2 {\n    width: 1.5rem;\n    height: 1.5rem;\n    line-height: 1.5rem;\n  }\n\n  &.btn-size3 {\n    width: 2.7504rem;\n    height: 2.7504rem;\n    line-height: 2.7504rem;\n  }\n\n  color:$color__white;\n  background: $color__primary;\n\n  &.btn-white {\n    background: $color__white;\n    color: $color__primary;\n  }\n}\n\n\n\n// -----------------------------\n// LIST DOCUMENTS\n// -----------------------------\n.documents {\n  color: $color__primary-dark;\n\n  .documents__header {\n    text-align: center;\n    margin-bottom: 1.25rem;\n  }\n\n  .documents__title {\n    font-size: 1.125rem;\n    font-weight: 600;\n    margin: 0.5rem 0px 0.5rem;\n  }\n\n  .documents__subtitle {\n    font-size: 0.875rem;\n    font-weight: 500;\n    margin: 0px auto;\n    max-width: 29rem;\n    line-height: 1.4;\n  }\n\n  .documents__empty {\n    font-weight: 600;\n    text-align: center;\n  }\n\n  // List\n  .documents__listwrapper {\n    max-height: 12.5rem;\n    overflow: auto;\n    width: 100%;\n    box-shadow: inset 1px 1px 3px 1px rgba(0, 102, 111, 0.3);\n    border-radius: 1rem;\n  }\n\n  .documents__list {\n    display: table;\n    margin: 0px 0px 0.75rem;\n    padding: 0px;\n    width: 100%;\n    overflow: hidden;\n  }\n\n  .documents__listitem {\n    display: table-row;\n    position: relative;\n\n    &+.documents__listitem::after {\n      content: '';\n      display: block;\n      position: absolute;\n      top: 0px;\n      left: 1.25rem;\n      right: 1.25rem;\n      border-top: 1px solid #697F8C;\n    }\n\n    .listitem__cb {\n      text-align: center;\n      width: 1.75rem;\n      padding-left: 0.875rem;\n\n      input {\n        width: 1rem;\n        height: 1rem;\n        border-color: $color__primary-dark;\n      }\n\n      input[type=\"checkbox\"] {\n        /* Masquer l'input checkbox d'origine */\n        display: none;\n      }\n\n      /* Style pour la case non cochée */\n      input[type=\"checkbox\"]+label:before {\n        content: \"\";\n        width: 16px;\n        height: 16px;\n        display: inline-block;\n        border-radius: 3px;\n        margin-right: 10px;\n        line-height: 20px;\n        border: 1px solid $color__primary-dark;\n        background-color: #fff;\n      }\n\n      /* Style pour la case cochée */\n      input[type=\"checkbox\"]:checked+label:before {\n        content: \"\\2713\";\n        /* Caractère unicode pour le symbole de coche */\n        font-size: 14px;\n        line-height: 20px;\n        text-align: center;\n        color: $color__orange;\n        //background-color: #007bff;\n      }\n    }\n\n    .listitem__icon {\n      width: 1.875rem;\n      text-align: center;\n      font-size: 1.125rem;\n      color: $color__orange;\n    }\n\n    .listitem__name {\n      font-size: 1rem;\n      font-weight: 500;\n      cursor:pointer;\n      @include functions.responsiveSmartphone {\n        span {\n          display: block;\n          width: 37vw;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n        }\n      }\n    }\n\n    .listitem__actions {\n      width: 8rem;\n      padding-right: 1.5rem;\n    }\n\n    .listitem__action {\n      text-decoration: none;\n      color: inherit;\n      outline: none;\n      font-size: 1.125rem;\n      margin: 0.125rem 0.25rem;\n\n      &:hover {\n        color: $color__primary;\n      }\n\n      &.item__action--delete:hover {\n        color: $color__red;\n      }\n\n      &.item__action--empty {\n        width: 18px;\n        display: inline-block;\n      }\n    }\n  }\n\n  .listitem__cell {\n    display: table-cell;\n    padding: 0.75rem 0.375rem;\n    vertical-align: middle;\n  }\n\n\n  // Group actions\n  .documents__groupactions {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 0.75rem;\n\n    .button {\n      padding-left: 1rem;\n      padding-right: 1rem;\n      font-size: 0.625rem;\n      font-weight: 600;\n\n      i {\n        margin-right: 0.25rem;\n      }\n\n      /*.icon-trash {\n        font-size: 0.875rem;\n        position: relative;\n        bottom: -0.125rem;\n        height: 0.625rem;\n        display: inline-block;\n        margin-right: 0.375rem;\n      }*/\n    }\n  }\n}\n\n\n// -----------------------------\n// SETTINGS\n// -----------------------------\n// First popup\n.need-interaction {\n  text-align: center;\n  max-width: 32.625rem;\n  margin: 0px auto;\n\n  p {\n    font-weight: 600;\n    font-size: 1.125rem;\n    margin-bottom: 1.5rem;\n  }\n\n  .button {\n    font-size: 1.125rem;\n    padding: 0.625rem 1.25rem;\n  }\n}\n\n// Settings\n.settings-video,\n.settings-audio,\n.settings-support,\n.test-device {\n\n\n  .test-device__title {\n    text-align: center;\n    font-size: 1.25rem;\n    font-weight: 600;\n    margin: 0.25rem 0px 1.875rem;\n  }\n\n  .test-device__start {\n    font-size: 1.125rem;\n    padding: 0.625rem 1.25rem;\n  }\n\n  .test-device__row {\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: flex-start;\n    width: 100%;\n  }\n\n  .test-device__col {\n    padding: 0.5rem;\n    flex: 0 0 50%;\n    width: 50%;\n  }\n\n  .settings__subtitle,\n  .test-device__subtitle {\n    font-size: 1rem;\n    font-weight: 600;\n    margin: 0px auto 1rem;\n    text-align: center;\n  }\n\n  .test-device__start {\n    margin-top: 2.5rem;\n    margin-left: auto;\n    margin-right: auto;\n    display: block;\n    width: auto;\n  }\n\n  .test-device__capteurs {\n    padding-left: 1rem;\n  }\n\n\n  &.test-device--patient {\n    .test-device__col {\n      flex: 0 0 33.33%;\n      width: 33.33%;\n    }\n  }\n\n\n  @include functions.responsiveMobile {\n    .test-device__row {\n      flex-wrap: wrap;\n    }\n\n    .test-device__col {\n      padding-left: 0px;\n      padding-right: 0px;\n      flex: 0 0 100%;\n      width: 100%;\n    }\n\n    &.test-device--patient {\n      .test-device__col {\n        flex: 0 0 100%;\n        width: 100%;\n      }\n    }\n  }\n\n  @include functions.responsiveSmartphone {\n    .test-device__col--capteurs {\n      display: none !important;\n    }\n  }\n}\n\n// -------------------------\n// Liste capteur item\n// -------------------------\n.capteur-item {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  margin-bottom: 0.75rem;\n\n  &__icon {\n    display: flex;\n    flex: 0 0 1.875rem;\n    height: 1.875rem;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid $color__primary-dark;\n    border-radius: 50%;\n    font-size: 1.125rem;\n    margin-right: 1rem;\n  }\n\n  &__name {\n    font-size: 0.875rem;\n    font-family: $font__quaternary;\n    font-weight: 600;\n  }\n\n  &__status {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-left: 0.25rem;\n    width: 1.375rem;\n    height: 1.375rem;\n    border-radius: 50%;\n    border: 2px solid $color__primary;\n    color: $color__primary;\n    font-size: 0.625rem;\n    margin-left: auto;\n\n    .capteur-item--disabled & {\n      color: $color__red;\n      border-color: $color__red;\n    }\n\n    .capteur-item--undefined & {\n      color: $color__orange;\n      border-color: $color__orange;\n  \n      .icon-exclamation {\n        font-size: 150%;\n      }\n    }\n  }\n\n  &__toggle {\n    margin-left: 1.25rem;\n    width: 52px;\n  }\n\n  @include functions.responsiveMobile {\n    &__toggle {\n      margin-left: 0.75rem;\n      width: 39px;\n    }\n    .device-toggle {\n      width: 39px;\n      height: 24px;\n      &__content {\n        width: 21px;\n      }\n    }\n  }\n}\n\n\n\n// -------------------------\n// Device toggle\n// -------------------------\n.device-toggle {\n  width: 52px;\n  height: 32px;\n  margin-left: auto;\n  border-radius: 15px;\n  display: flex;\n  align-self: center;\n\n  &--active {\n    background-color: $color__primary;\n    justify-content: end;\n  }\n\n  &--inactive {\n    background-color: #E0F0F3;\n    justify-content: start;\n  }\n\n  &__content {\n    width: 28px;\n    aspect-ratio: 1 / 1;\n    border: none;\n    border-radius: 15px;\n    margin: 2px;\n\n    .device-toggle--active & {\n      align-self: center;\n      align-items: flex-end;\n      background-color: $color__primary-dark;\n    }\n\n    .device-toggle--inactive & {\n      align-self: center;\n      background-color: $color__primary;\n    }\n  }\n}\n\n\n// -------------------------\n// Doc2u Toggle\n// -------------------------\n.doc2u-toggle {\n  display: flex;\n  flex-direction: row;\n  align-content: space-between;\n  width: 100%;\n  height: 58px;\n  box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 25%);\n  border-radius: 15px;\n  padding: 5px 10px 5px 10px;\n  .device-toggle--inactive {\n    box-shadow: inset 0 4px 8px rgba(0, 0, 0, 0.3);\n    background: #eee;\n  }\n\n  &__title {\n    width: 33%;\n    align-self: center;\n    font-size: 16px;\n    font-weight: 600;\n  }\n}\n\n\n\n\n.test-device {\n  @include functions.responsiveSmartphone {\n    .settings__subtitle {\n      background: $color__primary-light;\n      padding: 0.25rem 0px;\n      border-radius: 1rem 1rem 0px 0px;\n      margin-bottom: 0px;\n    }\n\n    .device-selector {\n      padding: 1rem;\n      border-radius: 0px 0px 1rem 1rem;\n      border: 1px solid $color_grey;\n      border-top-width: 0px;\n\n      .device-selector__label {\n        text-align: center;\n      }\n    }\n\n    .test-device__col {\n      order: 3;\n\n      &:nth-child(1) {\n        order: 4;\n      }\n    }\n  }\n}\n\n\n// Device selector\n.device-selector {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  margin-bottom: 1.25rem;\n\n  .device-selector__label {\n    font-size: 0.875rem;\n    font-weight: 600;\n    display: block;\n    margin-bottom: 0.25rem;\n    width: 100%;\n  }\n\n  .device-selector__input {\n    width: 100%;\n    font-size: 0.875rem;\n    font-weight: 500;\n    border: 1px solid $color__primary-dark;\n    padding: 0.5rem 2rem 0.5rem 0.625rem;\n    border-radius: 1rem;\n    color: $color__primary-dark;\n    outline: none;\n    box-shadow: none;\n    // &:focus {\n    //   border-color: $color__primary;\n    //   color: $color__primary;\n    // }\n  }\n\n  .device-selector__container {\n    position: relative;\n\n    .device-selector__input {\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n      background: transparent;\n    }\n\n    &:after {\n      content: \"\\e908\";\n      font-family: 'icomoon' !important;\n      position: absolute;\n      top: 0;\n      right: 0;\n      font-size: 0.875rem;\n      font-weight: 800;\n      padding: 0.8rem 0.625rem;\n      z-index: -1;\n    }\n  }\n\n  .device-selector__disable {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 2.25rem;\n    height: 2.25rem;\n    flex: 0 0 2.25rem;\n    margin-left: 1.25rem;\n    border-radius: 1.125rem;\n    border: none;\n    outline: none;\n    box-shadow: none;\n    background: $color__primary;\n    color: $color__white;\n    text-align: center;\n    font-size: 1rem;\n\n    &.device-selector__disable--disabled {\n      background: $color__red;\n    }\n  }\n\n\n  .device-selector__prefix {\n    font-size: 1.5rem;\n    margin-right: 0.5rem;\n  }\n\n  &.device-selector--iconed {\n    .device-selector__container {\n      width: calc(100% - 3.5rem);\n    }\n  }\n\n  &.device-selector--prefixed {\n    .device-selector__label {\n      padding-left: 2rem;\n    }\n\n    .device-selector__container {\n      width: calc(100% - 2rem);\n    }\n\n    &.device-selector--iconed {\n      .device-selector__container {\n        width: calc(100% - 5.5rem);\n      }\n    }\n  }\n}\n\n\n.cam-box {\n  .cam-box-content {\n    img {\n      max-width: 100%;\n      height: auto;\n    }\n  }\n}\n\n.device-workflow {\n  .device-workflow__actions {\n    text-align: center;\n    margin: 1rem 0px;\n  }\n\n  .refuse__title {\n    text-align: center;\n    font-size: 1.125rem;\n    margin: 0px auto 1rem;\n  }\n\n  .refuse__list {\n    li {\n      margin-bottom: 1rem;\n    }\n\n    img {\n      display: block;\n      margin: 0.5rem 0px;\n    }\n  }\n}\n\n.btn__notif {\n  display: flex;\n  position: relative;\n  align-items: center;\n  justify-content: center;\n  width: 1rem;\n  height: 1rem;\n  font-size: 0.5rem;\n  background: $color__red;\n  color: $color__white;\n  position: absolute;\n  top: 0.375rem;\n  right: 0.375rem;\n  border-radius: 50%;\n  font-weight: 900;\n}\n\n\n\n\n// -----------------------------\n// SETTINGS\n// -----------------------------\n.settings-video,\n.settings-audio,\n.settings-support {\n  .settings__subtitle {\n    font-size: 1.125rem;\n    margin-bottom: 0.625rem;\n    ;\n  }\n\n  @include functions.responsiveSmartphone {\n    .device-selector-wrapper {\n      padding: 0.75rem;\n      border: 1px solid $color_grey;\n      border-radius: 1rem;\n      width: calc(100% - 2rem);\n      margin: 1rem;\n    }\n  }\n}\n\n\n.settings-support {\n  max-width: 31.5rem;\n  margin: 0px auto;\n  text-align: center;\n  font-size: 0.875rem;\n\n  .settings__block {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: nowrap;\n  }\n\n  p {\n    margin: 0px 0px 0.875rem;\n  }\n\n  .settings-support__submitwrap {\n    margin-bottom: auto;\n  }\n\n  .settings-support__submit {\n    font-size: 0.75rem;\n    padding-top: 0.625rem;\n    padding-bottom: 0.625rem;\n  }\n\n  .settings-support__info {\n    max-width: 22rem;\n    margin: 3rem auto 0rem;\n    font-size: 0.75rem;\n    padding: 0.625rem;\n    border: 1px solid $color__primary;\n    border-radius: 1rem;\n  }\n\n  @include functions.responsiveSmartphone {\n\n    &,\n    .settings__block {\n      height: 100%;\n    }\n\n    .settings-support__info {\n      margin-top: auto;\n      margin-bottom: 0;\n    }\n  }\n}\n\n.settings-audio {\n  .test-device__row {\n    align-items: center;\n  }\n\n  .settings__block {\n    max-width: 17rem;\n    margin-left: auto;\n    margin-right: auto;\n\n    @include functions.responsiveSmartphone {\n      max-width: 100%;\n    }\n  }\n\n  .settings__block--audiometer,\n  .settings__block--audiooutput {\n    min-height: 3.75rem;\n    margin-bottom: 1.125rem;\n\n    @include functions.responsiveSmartphone {\n      margin-bottom: 0.25rem;\n      min-height: auto;\n    }\n  }\n\n  .settings__block--audiometer {\n    padding-top: 0.875rem;\n    max-width: 14rem;\n    margin-left: auto;\n    margin-right: auto;\n\n    label {\n      display: block;\n      margin-bottom: 0.5rem;\n    }\n  }\n\n  .settings__block--audiooutput {\n    max-width: 14rem;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex;\n    align-items: center;\n\n    i {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      width: 2.25rem;\n      height: 2.25rem;\n      border-radius: 50%;\n      background: $color__primary;\n      color: $color__white;\n      font-size: 1.375rem;\n      margin-left: 0.5rem;\n      flex-grow: 0;\n      flex-shrink: 0;\n    }\n  }\n\n  .settings-audio__volume {\n    display: flex;\n    align-items: center;\n    flex-wrap: nowrap;\n\n    .range {\n      flex: 0 1 17.75rem;\n    }\n\n    i {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      width: 2.25rem;\n      height: 2.25rem;\n      border-radius: 50%;\n      background: $color__primary;\n      color: $color__white;\n      font-size: 1.375rem;\n      flex-grow: 0;\n      flex-shrink: 0;\n      cursor: pointer;\n\n      &:first-child {\n        margin-right: 0.5rem;\n      }\n\n      &:last-child {\n        margin-left: 0.5rem;\n      }\n    }\n\n\n\n    @include functions.responsiveSmartphone {\n      .range {\n        &__input {\n          height: 0.375rem;\n          border-radius: 0.375rem;\n          // border: 1px solid $color__primary;\n          // border-width: 0.5px;\n\n          &::-webkit-slider-thumb {\n            height: 0.875rem;\n            width: 0.875rem;\n            border-width: 1px;\n          }\n        }\n      }\n    }\n  }\n}\n\n.settings-video {\n  .test-device__col {\n    &:first-child {\n      flex: 0 0 62%;\n      width: 62%;\n    }\n\n    &:last-child {\n      flex: 0 0 38%;\n      width: 38%;\n    }\n  }\n\n  @include functions.responsiveSmartphone {\n    .test-device__col {\n      order: 2;\n\n      &,\n      &:first-child,\n      &:last-child {\n        flex: 0 0 100%;\n        width: 100%;\n      }\n\n      &:first-child {\n        order: 3;\n      }\n    }\n  }\n}\n\n/*\nbody:not(.onetoone-type-extern) {\n  video:not(.screen-video):not([data-sessionrole=\"extern\"]) {\n    transform: rotateY(180deg);\n    -webkit-transform: rotateY(180deg);\n    // Safari and Chrome\n    -moz-transform: rotateY(180deg);\n    // Firefox \n  }\n}*/\n\n#webcam-preview {\n  transform: rotateY(180deg);\n    -webkit-transform: rotateY(180deg);\n    // Safari and Chrome\n    -moz-transform: rotateY(180deg);\n    // Firefox \n}\n\n.onetoone-type-extern #webcam-preview { \n  transform: inherit;\n  -webkit-transform: inherit;\n  -moz-transform: inherit;\n}\n\nbody .lightbox-media video {\n  transform: inherit !important;\n  -webkit-transform: inherit !important;\n  /* Safari and Chrome */\n  -moz-transform: inherit !important;\n  /* Firefox */\n}\n\n\n\n@include functions.responsiveMobile {\n  .test-device__col {\n\n    &:first-child,\n    &:last-child {\n      flex: 0 0 100%;\n      width: 100%;\n    }\n  }\n}\n\n.hoco_title{\n  font-size: 1.25rem;\n  line-height: 1.3;\n  margin: 0px auto 0.625rem;\n  text-align: center;\n  max-width: 32rem;\n  font-family: inherit;\n  font-weight: 600;\n}\n\n.hoco_subtitle{\n  text-align: center;\n  max-width: 32rem;\n  margin: 0.625rem auto 4rem;\n  font-family: inherit;\n  font-weight: 600;\n}","// =============================================================================\n// Normalize.scss based on Nicolas Gallagher and Jonathan Neal's\n// normalize.css v2.1.3 | MIT License | git.io/normalize\n// =============================================================================\n\n// =============================================================================\n// Normalize.scss settings\n// =============================================================================\n\n\n// Set to true if you want to add support for IE6 and IE7\n// Notice: setting to true might render some elements\n// slightly differently than when set to false\n$legacy_support_for_ie: false !default; // Used also in Compass\n\n\n// Set the default font family here so you don't have to override it later\n$normalized_font_family: sans-serif !default;\n\n$normalize_headings: true !default;\n\n$h1_font_size: 2em !default;\n$h2_font_size: 1.5em !default;\n$h3_font_size: 1.17em !default;\n$h4_font_size: 1em !default;\n$h5_font_size: 0.83em !default;\n$h6_font_size: 0.75em !default;\n \n$h1_margin: 0.67em 0 !default;\n$h2_margin: 0.83em 0 !default;\n$h3_margin: 1em 0 !default;\n$h4_margin: 1.33em 0 !default;\n$h5_margin: 1.67em 0 !default;\n$h6_margin: 2.33em 0 !default;\n\n$background: #fff !default;\n$color: #000 !default;\n\n// =============================================================================\n// HTML5 display definitions\n// =============================================================================\n\n// Corrects block display not defined in IE6/7/8/9 & FF3\n\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nnav,\nsection,\nsummary {\n\tdisplay: block;\n}\n\n// Corrects inline-block display not defined in IE6/7/8/9 & FF3\n\naudio,\ncanvas,\nvideo {\n\tdisplay: inline-block;\n\t@if $legacy_support_for_ie {\n\t\t*display: inline;\n\t\t*zoom: 1;\n\t}\n}\n\n// 1. Prevents modern browsers from displaying 'audio' without controls\n// 2. Remove excess height in iOS5 devices\n\naudio:not([controls]) {\n\tdisplay: none; // 1\n\theight: 0; // 2\n}\n\n//\n// Address `[hidden]` styling not present in IE 8/9.\n// Hide the `template` element in IE, Safari, and Firefox < 22.\n//\n\n[hidden], template {\n\tdisplay: none;\n}\n\n// =============================================================================\n// Base\n// =============================================================================\n\n// 1. Corrects text resizing oddly in IE6/7 when body font-size is set using em units\n//    http://clagnut.com/blog/348/#c790\n// 2. Prevents iOS text size adjust after orientation change, without disabling user zoom\n//    www.456bereastreet.com/archive/201012/controlling_text_size_in_safari_for_ios_without_disabling_user_zoom/\n\nhtml {\n\t@if $legacy_support_for_ie {\n\t\tfont-size: 100%; // 1\n\t}\n\t\tbackground: $background;\n\t\tcolor: $color;\n\t-webkit-text-size-adjust: 100%; // 2\n\t-ms-text-size-adjust: 100%; // 2\n}\n\n// Addresses font-family inconsistency between 'textarea' and other form elements.\n\nhtml,\nbutton,\ninput,\nselect,\ntextarea {\n\tfont-family: $normalized_font_family;\n}\n\n// Addresses margins handled incorrectly in IE6/7\n\nbody {\n\tmargin: 0;\n}\n\n// =============================================================================\n// Links\n// =============================================================================\n\n// 1. Remove the gray background color from active links in IE 10.\n// 2. Addresses outline displayed oddly in Chrome\n// 3. Improves readability when focused and also mouse hovered in all browsers\n//    people.opera.com/patrickl/experiments/keyboard/test\n\na {\n\t// 1\n\t\n\tbackground: transparent;\n\n\t// 2\n\n\t&:focus {\n\t\toutline: thin dotted;\n\t}\n\n\t// 3\n\n\t&:hover,\n\t&:active {\n\t\toutline: 0;\n\t}\n}\n\n// =============================================================================\n// Typography\n// =============================================================================\n\n// Addresses font sizes and margins set differently in IE6/7\n// Addresses font sizes within 'section' and 'article' in FF4+, Chrome, S5\n\n@if $normalize_headings == true {\n\th1 {\n\t\tfont-size: $h1_font_size;\n\t\tmargin: $h1_margin;\n\t}\n\n\th2 {\n\t\tfont-size: $h2_font_size;\n\t\tmargin: $h2_margin;\n\t}\n\n\th3 {\n\t\tfont-size: $h3_font_size;\n\t\tmargin: $h3_margin;\n\t}\n\n\th4 {\n\t\tfont-size: $h4_font_size;\n\t\tmargin: $h4_margin;\n\t}\n\n\th5 {\n\t\tfont-size: $h5_font_size;\n\t\tmargin: $h5_margin;\n\t}\n\n\th6 {\n\t\tfont-size: $h6_font_size;\n\t\tmargin: $h6_margin;\n\t}\n}\n\n// Addresses styling not present in IE 8/9, S5, Chrome\n\nabbr[title] {\n\tborder-bottom: 1px dotted;\n}\n\n// Addresses style set to 'bolder' in FF3+, S4/5, Chrome\n\nb,\nstrong {\n\tfont-weight: bold;\n}\n\n@if $legacy_support_for_ie {\n\tblockquote {\n\t\tmargin: 1em 40px;\n\t}\n}\n\n// Addresses styling not present in S5, Chrome\n\ndfn {\n\tfont-style: italic;\n}\n\n// Addresses styling not present in IE6/7/8/9\n\nmark {\n\tbackground: #ff0;\n\tcolor: #000;\n}\n\n// Addresses margins set differently in IE6/7\n@if $legacy_support_for_ie {\n\tp,\n\tpre {\n\t\tmargin: 1em 0;\n\t}\n}\n\n// Corrects font family set oddly in IE6, S4/5, Chrome\n// en.wikipedia.org/wiki/User:Davidgothberg/Test59\n\ncode,\nkbd,\npre,\nsamp {\n\tfont-family: monospace, serif;\n\t@if $legacy_support_for_ie {\n\t\t_font-family: 'courier new', monospace;\n\t}\n\tfont-size: 1em;\n}\n\n// Improves readability of pre-formatted text in all browsers\n\npre {\n\twhite-space: pre;\n\twhite-space: pre-wrap;\n\tword-wrap: break-word;\n}\n\n// Set consistent quote types.\n\nq {\n\tquotes: \"\\201C\" \"\\201D\" \"\\2018\" \"\\2019\";\n}\n\n// 1. Addresses CSS quotes not supported in IE6/7\n// 2. Addresses quote property not supported in S4\n\n// 1\n@if $legacy_support_for_ie {\n\tq {\n\t\tquotes: none;\n\t}\n}\n\n// 2\nq {\n\t&:before, \n\t&:after {\n\t\tcontent: '';\n\t\tcontent: none;\t\n\t}\n}\n\n// Address inconsistent and variable font size in all browsers.\n\nsmall {\n\tfont-size: 80%;\n}\n\n// Prevents sub and sup affecting line-height in all browsers\n// gist.github.com/413930\n\nsub,\nsup {\n\tfont-size: 75%;\n\tline-height: 0;\n\tposition: relative;\n\tvertical-align: baseline;\n}\n\nsup {\n\ttop: -0.5em;\n}\n\nsub {\n\tbottom: -0.25em;\n}\n\n// =============================================================================\n// Lists\n// =============================================================================\n\n// Addresses margins set differently in IE6/7\n@if $legacy_support_for_ie {\n\tdl,\n\tmenu,\n\tol,\n\tul {\n\t\tmargin: 1em 0;\n\t}\n}\n\n@if $legacy_support_for_ie {\n\tdd {\n\t\tmargin: 0 0 0 40px;\n\t}\n}\n\n// Addresses paddings set differently in IE6/7\n@if $legacy_support_for_ie {\n\tmenu,\n\tol,\n\tul {\n\t\tpadding: 0 0 0 40px;\n\t}\n}\n\n// Corrects list images handled incorrectly in IE7\n\nnav {\n\tul,\n\tol {\n\t\t@if $legacy_support_for_ie {\n\t\t\tlist-style-image: none;\n\t\t}\n\t}\n}\n\n// =============================================================================\n// Embedded content\n// =============================================================================\n\n// 1. Removes border when inside 'a' element in IE6/7/8/9, FF3\n// 2. Improves image quality when scaled in IE7\n//    code.flickr.com/blog/2008/11/12/on-ui-quality-the-little-things-client-side-image-resizing/\n\nimg {\n\tborder: 0; // 1\n\t@if $legacy_support_for_ie {\n\t\t-ms-interpolation-mode: bicubic; // 2\n\t}\n}\n\n// Corrects overflow displayed oddly in IE9\n\nsvg:not(:root) {\n\toverflow: hidden;\n}\n\n// =============================================================================\n// Figures\n// =============================================================================\n\n// Addresses margin not present in IE6/7/8/9, S5, O11\n\nfigure {\n\tmargin: 0;\n}\n\n// =============================================================================\n// Forms\n// =============================================================================\n\n// Corrects margin displayed oddly in IE6/7\n@if $legacy_support_for_ie {\n\tform {\n\t\tmargin: 0;\n\t}\n}\n\n// Define consistent border, margin, and padding\n\nfieldset {\n\tborder: 1px solid #c0c0c0;\n\tmargin: 0 2px;\n\tpadding: 0.35em 0.625em 0.75em;\n}\n\n// 1. Corrects color not being inherited in IE6/7/8/9\n// 2. Remove padding so people aren't caught out if they zero out fieldsets.\n// 3. Corrects text not wrapping in FF3\n// 4. Corrects alignment displayed oddly in IE6/7\n\nlegend {\n\tborder: 0; // 1\n\tpadding: 0; // 2\n\twhite-space: normal; // 3\n\t@if $legacy_support_for_ie {\n\t\t*margin-left: -7px; // 4\n\t}\n}\n\n// 1. Correct font family not being inherited in all browsers.\n// 2. Corrects font size not being inherited in all browsers\n// 3. Addresses margins set differently in IE6/7, FF3+, S5, Chrome\n// 4. Improves appearance and consistency in all browsers\n\nbutton,\ninput,\nselect,\ntextarea {\n\tfont-family: inherit; // 1\n\tfont-size: 100%; // 2\n\tmargin: 0; // 3\n\tvertical-align: baseline; // 4\n\t@if $legacy_support_for_ie {\n\t\t*vertical-align: middle; // 4\n\t}\n}\n\n// Addresses FF3/4 setting line-height on 'input' using !important in the UA stylesheet\n\nbutton, input {\n\tline-height: normal;\n}\n\n// Address inconsistent `text-transform` inheritance for `button` and `select`.\n// All other form control elements do not inherit `text-transform` values.\n// Correct `button` style inheritance in Chrome, Safari 5+, and IE 8+.\n// Correct `select` style inheritance in Firefox 4+ and Opera.\n\nbutton,\nselect {\n\ttext-transform: none;\n}\n\n// 1. Avoid the WebKit bug in Android 4.0.* where (2) destroys native `audio`\n//    and `video` controls\n// 2. Corrects inability to style clickable 'input' types in iOS\n// 3. Improves usability and consistency of cursor style between image-type\n//    'input' and others\n// 4. Removes inner spacing in IE7 without affecting normal text inputs\n//    Known issue: inner spacing remains in IE6\n\nbutton,\nhtml input[type=\"button\"], // 1\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n\t-webkit-appearance: button; // 2\n\tcursor: pointer; // 3\n\t@if $legacy_support_for_ie {\n\t\t*overflow: visible;  // 4\n\t}\n}\n\n// Re-set default cursor for disabled elements\n\nbutton[disabled],\ninput[disabled] {\n\tcursor: default;\n}\n\n// Removes inner padding and border in FF3+\n// www.sitepen.com/blog/2008/05/14/the-devils-in-the-details-fixing-dojos-toolbar-buttons/\n\nbutton, input {\n\t&::-moz-focus-inner {\n\t\tborder: 0;\n\t\tpadding: 0;\n\t}\n}\n\n// 1. Removes default vertical scrollbar in IE6/7/8/9\n// 2. Improves readability and alignment in all browsers\n\ntextarea {\n\toverflow: auto; // 1\n\tvertical-align: top; // 2\n}\n\n// =============================================================================\n// Tables\n// =============================================================================\n\n// Remove most spacing between table cells\n\ntable {\n\tborder-collapse: collapse;\n\tborder-spacing: 0;\n}\n\ninput {\n\t// 1. Addresses appearance set to searchfield in S5, Chrome\n\t// 2. Addresses box-sizing set to border-box in S5, Chrome (include -moz to future-proof)\n\t&[type=\"search\"] {\n\t\t-webkit-appearance: textfield; // 1\n\t\t-moz-box-sizing: content-box;\n\t\t-webkit-box-sizing: content-box; // 2\n\t\tbox-sizing: content-box;\n\t\t\n\t\t// Remove inner padding and search cancel button in Safari 5 and Chrome\n\t\t// on OS X.\n\t\t&::-webkit-search-cancel-button,\n\t\t&::-webkit-search-decoration {\n\t\t\t-webkit-appearance: none;\n\t\t}\n\t}\n\t\n\t// 1. Address box sizing set to `content-box` in IE 8/9/10.\n\t// 2. Remove excess padding in IE 8/9/10.\n\t// 3. Removes excess padding in IE7\n\t//    Known issue: excess padding remains in IE6\n\t&[type=\"checkbox\"],\n\t&[type=\"radio\"] {\n\t\tbox-sizing: border-box; // 1\n\t\tpadding: 0; // 2\n\t\t@if $legacy_support_for_ie {\n\t\t\t*height: 13px; // 3\n\t\t\t*width: 13px; // 3\n\t\t}\n\t}\n}","@use './abstracts/variables' as *;\n@use './abstracts/functions';\n\n\n\n@font-face {\n  font-family: 'icomoon';\n  src:\n    functions.font('icomoon.ttf?mw673m') format('truetype'),\n    functions.font('icomoon.woff?mw673m') format('woff'),\n    functions.font('icomoon.svg?mw673m#icomoon') format('svg');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n[class^=\"icon-\"],\n[class*=\" icon-\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'icomoon' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n\n\n$icons: (\n  default: \"\\e946\",\n  camera-deportee:\"\\e947\",\n  medical-info: \"\\e945\",\n  plus: \"\\e944\",\n  minus: \"\\e943\",\n  fullscreen: \"\\e941\",\n  fullscreen_exit: \"\\e942\",\n  cake: \"\\e93a\",\n  gender: \"\\e93b\",\n  glycemie: \"\\e93c\",\n  meter: \"\\e93d\",\n  oxymetrie: \"\\e93e\",\n  temp: \"\\e93f\",\n  weight: \"\\e940\",\n  doc2u: \"\\e900\",\n  cam: \"\\e901\",\n  camera: \"\\e902\",\n  cam-off: \"\\e903\",\n  cancel: \"\\e904\",\n  check: \"\\e905\",\n  checkbox: \"\\e906\",\n  checkbox-checked: \"\\e907\",\n  chevron-down: \"\\e908\",\n  chevron-up: \"\\e909\",\n  dermatoscope: \"\\e90a\",\n  docs: \"\\e90b\",\n  download: \"\\e90c\",\n  download-zip: \"\\e90d\",\n  echographe-doppler: \"\\e90e\",\n  electrocardiogramme: \"\\e90f\",\n  exit: \"\\e910\",\n  expand: \"\\e911\",\n  file-audio: \"\\e912\",\n  file-camera: \"\\e913\",\n  file-doc: \"\\e914\",\n  file-link: \"\\e915\",\n  file-pdf: \"\\e916\",\n  file-video: \"\\e917\",\n  focus: \"\\e918\",\n  hangup: \"\\e919\",\n  menu: \"\\e91a\",\n  messages: \"\\e91b\",\n  messages-off: \"\\e91c\",\n  mic: \"\\e91d\",\n  mic-off: \"\\e91e\",\n  otoscope: \"\\e91f\",\n  phone-ring: \"\\e920\",\n  print: \"\\e921\",\n  record: \"\\e922\",\n  recorded: \"\\e923\",\n  screenshare: \"\\e924\",\n  screenshare-off: \"\\e925\",\n  settings: \"\\e926\",\n  spirometre: \"\\e927\",\n  trash: \"\\e928\",\n  trombone: \"\\e929\",\n  view: \"\\e92a\",\n  warning: \"\\e92b\",\n  plane: \"\\e92c\",\n  stethoscope: \"\\e92d\",\n  speaker: \"\\e92e\",\n  quality-down: \"\\e92f\",\n  quality-up: \"\\e930\",\n  speaker-alt: \"\\e931\",\n  volume-down: \"\\e932\",\n  volume-up: \"\\e933\",\n  speaker-off: \"\\e934\",\n  exclamation: \"\\e935\",\n  back: \"\\e936\",\n  hamburger: \"\\e937\",\n  flashlight: \"\\e938\",\n  switchcam: \"\\e939\"\n\n);\n\n.device-item-icon{\n  [class^=\"icon-\"],\n   [class*=\" icon-\"] {\n     &:before{\n       content: \"\\e946\";\n     }\n   }\n }\n @each $key, $value in $icons {\n  .device-item-icon .icon-#{$key}:before,\n   .icon-#{$key}:before {\n     content: $value;\n   }\n }","@use './abstracts/variables' as *;\n@use './abstracts/functions';\n\n@font-face {\n  font-family: 'Filson Pro';\n  src: functions.font('Filson/FilsonPro-Bold.eot');\n  src: functions.font('Filson/FilsonPro-Bold.eot?#iefix') format('embedded-opentype'),\n      functions.font('Filson/FilsonPro-Bold.woff2') format('woff2'),\n      functions.font('Filson/FilsonPro-Bold.woff') format('woff'),\n      functions.font('Filson/FilsonPro-Bold.ttf') format('truetype');\n  font-weight: bold;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Filson Pro';\n  src: functions.font('Filson/FilsonPro-Light.eot');\n  src: functions.font('Filson/FilsonPro-Light.eot?#iefix') format('embedded-opentype'),\n      functions.font('Filson/FilsonPro-Light.woff2') format('woff2'),\n      functions.font('Filson/FilsonPro-Light.woff') format('woff'),\n      functions.font('Filson/FilsonPro-Light.ttf') format('truetype');\n  font-weight: 300;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Filson Pro';\n  src: functions.font('Filson/FilsonPro-Regular.eot');\n  src: functions.font('Filson/FilsonPro-Regular.eot?#iefix') format('embedded-opentype'),\n      functions.font('Filson/FilsonPro-Regular.woff2') format('woff2'),\n      functions.font('Filson/FilsonPro-Regular.woff') format('woff'),\n      functions.font('Filson/FilsonPro-Regular.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Filson Pro';\n  src: functions.font('Filson/FilsonPro-Medium.eot');\n  src: functions.font('Filson/FilsonPro-Medium.eot?#iefix') format('embedded-opentype'),\n      functions.font('Filson/FilsonPro-Medium.woff2') format('woff2'),\n      functions.font('Filson/FilsonPro-Medium.woff') format('woff'),\n      functions.font('Filson/FilsonPro-Medium.ttf') format('truetype');\n  font-weight: 500;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Omnes';\n  src: functions.font('Omnes/Omnes-SemiBold.eot');\n  src: functions.font('Omnes/Omnes-SemiBold.eot?#iefix') format('embedded-opentype'),\n      functions.font('Omnes/Omnes-SemiBold.woff2') format('woff2'),\n      functions.font('Omnes/Omnes-SemiBold.woff') format('woff'),\n      functions.font('Omnes/Omnes-SemiBold.ttf') format('truetype');\n  font-weight: 600;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Omnes';\n  src: functions.font('Omnes/Omnes-Bold.eot');\n  src: functions.font('Omnes/Omnes-Bold.eot?#iefix') format('embedded-opentype'),\n      functions.font('Omnes/Omnes-Bold.woff2') format('woff2'),\n      functions.font('Omnes/Omnes-Bold.woff') format('woff'),\n      functions.font('Omnes/Omnes-Bold.ttf') format('truetype');\n  font-weight: bold;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Omnes';\n  src: functions.font('Omnes/Omnes-Regular.eot');\n  src: functions.font('Omnes/Omnes-Regular.eot?#iefix') format('embedded-opentype'),\n      functions.font('Omnes/Omnes-Regular.woff2') format('woff2'),\n      functions.font('Omnes/Omnes-Regular.woff') format('woff'),\n      functions.font('Omnes/Omnes-Regular.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}","@use './abstracts/functions';\n\n$pictos: (\n  modal-alert: 'modal-alert.png',\n  outil-share: 'outil-share.png',\n  outil-record: 'outil-record.png',\n  outil-snapshoot: 'outil-snapshoot.png',\n  outil-micro: 'outil-micro.png',\n  outil-speaker: 'outil-speaker.png',\n);\n\n[class^=\"picto-\"], [class*=\" picto-\"] {\n  display: inline-block;\n  width: 1rem;\n  height: 1rem;\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: center;\n}\n\n@each $key, $value in $pictos {\n  .picto-#{$key} {\n    background-image: functions.picto($value);\n  }\n}","@use './abstracts/variables' as *;\n@use './abstracts/functions';\n\n.button {\n    display: inline-block;\n    margin-bottom: 0;\n\n    font-family: $font__primary;\n\tline-height: 1.2;\n\ttext-align: center;\n\tvertical-align: middle;\n    font-weight: 600;\n    font-size: 1.125rem;\n    padding: 0.625rem;\n\t/*padding: 0.25rem 2rem;\n\tfont-size: 0.875rem;\n    font-weight: 500;*/    \n\tcursor: pointer;\n    background: $color__white;\n\tborder: 1px solid transparent;\n    border-radius: 1rem;\n    box-shadow: none;\n    outline: none;\n    color: $color__black;\n    transition: all 0.3s linear;\n\n    &--medical {\n        font-family: $font__quaternary;\n        font-weight: 600;\n        padding-top: 0.125rem;\n        font-size: 1rem;\n    }\n\n\t// Hover/focus state\n\t&:hover,\n\t&:focus {\n        color: $color__black;\n\t\ttext-decoration: none;\n\t}\n\n\t// Active state\n\t&.active,\n\t&:active {\n\t\toutline: none;\n        box-shadow: none;\n\t}\n\n\t// Disabled state\n\t&.disabled,\n\t&[disabled] {\n\t\tcursor: not-allowed;\n        opacity: 0.65;\n\t}\n}\n\n@each $key, $color in $theme__colors {\n    .button--#{$key} {\n        color: $color__white;\n        background: $color;\n        border-color: $color;\n\n        &:hover,\n        &:focus {\n            color: $color__white;\n            background: darken($color, 10%);\n            border-color: darken($color, 10%);\n        }\n\n        @if $key == 'primary' {\n            &.button--medical {\n                background: #1DADB5;\n                border-color: #1DADB5;\n\n                &:hover,\n                &:focus {\n                    background: darken(#1DADB5, 10%);\n                    border-color: darken(#1DADB5, 10%);\n                }\n            }\n        }\n\n        &.button--outline {\n            background: $color__white;\n            color: $color;\n\n            &:hover,\n            &:focus {\n                background: $color__white;\n                color: darken($color, 10%);\n            }\n\n            @if $key == 'primary' {\n                &.button--medical {\n                    border-width: 2px;\n                    border-color: $color__primary-dark;\n                    color: $color__primary-dark;\n    \n                    &:hover,\n                    &:focus {\n                        border-color: lighten($color__primary-dark, 10%);\n                        color: lighten($color__primary-dark, 10%);\n                    }\n                }\n            }\n        }\n    }\n}","// Screen sizes\n$screen-sm: 576px;\n$screen-md: 768px;\n$screen-lg: 992px;\n$screen-xl: 1200px;\n$screen-xxl: 1440px;\n$screen-full: 1920px;\n\n// Colors\n$color__white: #FDFBFB;\n$color__red: #FF4958;\n$color__orange: #F4981C;\n$color__black: #000000;\n$color_grey: #EEE7E1;\n$color-darkgrey: #697F8C;\n\n\n$color__primary: #1DADB5;\n$color__primary-alt: #007E94;\n$color__primary-dark: #00666F;\n$color__primary-light: #D3F1F2;\n\n$color__secondary-dark: #7D748D;\n$color__secondary: #ACA6B7;\n$color__secondary-light1: #E8E5EC;\n$color__secondary-light2: #F6F5F8;\n\n\n$color__ternary: #333c50;\n\n$theme__colors: (\n    \"primary\": $color__primary, \n    \"dark\": $color__black, \n    \"danger\": $color__red, \n    \"warning\": $color__orange\n);\n\n$font__primary: 'Exo', sans-serif;\n$font__secondary: 'Inter', sans-serif;\n\n$font__ternary: 'Filson Pro', sans-serif;\n$font__quaternary: 'Omnes', sans-serif;\n\n$size__text: 1rem;\n\n$font__text: $font__primary;\n$font__title: $font__primary;\n\n$border-radius1 : 10px;\n$border-radius2 : 15px;\n$border-radius3 : 20px;\n\n$marge1:5px;\n$marge2:10px;\n$marge3:5px;","@use './abstracts/variables' as *;\n@use './abstracts/functions';\n\n\n\n// ----------------------------\n// PROGRESS\n// ----------------------------\n.progress {\n    display: block;\n    width: 100%;\n    text-align: center;\n    font-size: 0.75rem;\n    font-weight: 600;\n\n    &__text {\n\n    }\n\n    &__bar {\n        border: 1px solid $color__primary;\n        background: $color__white;\n        height: 0.75rem;\n        border-radius: 0.375rem;\n        position: relative;\n    }\n\n    &__value {\n        background: $color__primary;\n        height: 100%;\n        margin: 0px;\n        transition: width 0.3s ease-in-out;\n        border-radius: inherit;\n    }\n\n    &.progress--textinside {\n        position: relative;\n        .progress__text {\n            position: absolute;\n            top: 2px;\n            left: 50%;\n            transform: translateX(-50%);\n            font-size: 0.5rem;\n            color: $color__white;\n            z-index: 1;\n        }\n    }\n\n    &.progress--light {\n        color: $color__white;\n        .progress__bar {\n            border-color: $color__white;\n            background: $color__primary;\n        }\n        .progress__value {\n            background: $color__white;\n        }\n    }\n    &.progress--textinside {\n        .progress__text {\n            color: $color__primary;\n        }\n    }\n}\n  \n\n// ----------------------------\n// RANGE\n// ----------------------------\n.range {\n    &__input {\n        width: 100%;\n        -webkit-appearance: none;\n        box-shadow: none;\n        border: none;\n        height: 0.625rem;\n        background: $color__white;\n        border-radius: 1rem;\n        border: 1px solid $color__primary;\n        border-width: 0.5px;\n        background-image: linear-gradient($color__primary, $color__primary);\n        background-repeat: no-repeat;\n\n        &::-webkit-slider-thumb {\n            -webkit-appearance: none;\n            height: 1.125rem;\n            width: 1.125rem;\n            border-radius: 50%;\n            background: $color__white;\n            cursor: pointer;\n            box-shadow: none;\n            border: 2px solid $color__primary;\n            border-radius: 1.5px;\n            border-radius: 50%;\n        }\n\n        &::-webkit-slider-runnable-track {\n            -webkit-appearance: none;\n            box-shadow: none;\n            border: none;\n            background: transparent;\n        }\n    }\n    &.muted{\n        cursor: default;\n        opacity: 0.7;\n        &::-webkit-slider-thumb,\n        &::-webkit-slider-runnable-track {\n            cursor: default !important;\n        }\n        .range-plus, .range-moins{\n            cursor: default !important;\n            opacity: 0.7;\n        }\n    }\n}\n\n.icon-range {\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: center;\n    &__icon {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 1.875rem;\n        height: 1.875rem;\n        background: $color__white;\n        border-radius: 50%;\n        border: 1px solid $color__primary;\n        border-width: 0.5px;\n        margin-right: 0.625rem;\n        .picto-outil-speaker {\n            width: 1.25rem;\n            height: 1.25rem;\n        }\n    }\n    &__input {\n        flex: 1 1 auto;\n    }\n\n    &.icon-range--vertical {\n        flex-direction: column;\n        .icon-range__icon {\n            margin-right: 0px;\n            margin-bottom: 0.625rem;\n        }\n        .icon-range__input {\n            transform: rotate(-90deg);\n            padding-bottom: 25%;\n            padding-top: 25%;\n        }\n    }\n}\n\n\n\n// -----------------------------\n// VISIO VOLUME CONTROL\n// -----------------------------\n.range-plus, .range-moins {\n    display: none;\n}\n.volume-control {\n    max-width: 100%;\n    position: relative;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n    margin: 5px 0px 5px 1rem;\n    .volume-control__mute {\n        margin: 0px 0.125rem 0px 0px;\n        width: 1.875rem;\n        height: 1.875rem;\n        line-height: 1.875rem;\n        padding: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background: $color__white;\n        border: 1px solid $color__primary;\n        border-radius: 50%;\n        outline: none;\n        box-shadow: none;\n        font-size: 1rem;\n        color: $color__primary-dark;\n\n        &.muted {\n            color: $color__red;\n            border-color: $color__red;\n        }\n    }\n\n    .range {\n        width: 16rem;\n        .range-plus,\n        .range-moins {\n            user-select: none;\n            content: '';\n            display: none;\n            align-items: center;\n            justify-content: center;\n            width: 1.25rem;\n            height: 1.25rem;\n            position: absolute;\n            background: rgba($color__white, 0.8);\n            color: $color__primary;\n            border-radius: 0.25rem;\n            font-size: 1.5rem;\n            cursor:pointer;\n        }\n        .range-plus {\n            right: -2rem;\n        }\n        .range-moins {\n            left: -2rem;\n            bottom: 0;\n            transform: rotate(-90deg);\n        }\n        @include functions.responsiveMobile {\n            width: 7rem;\n        }\n    }\n}\n\n\n\n// -----------------------------\n// VIDEO BLOCK\n// -----------------------------\n.video-block {\n    position: relative;\n    border-radius: 1.25rem;\n    overflow: hidden;\n    width: 100%;\n    \n    & + .video-block {\n        margin-top: 1rem;\n    }\n    .video-block__video {\n        height: auto;\n        margin: 0px;\n        display: block;\n        width: 100%;\n    }\n    .video-block__audiometer {\n\n    }\n    .video-block__placeholder {\n        position: absolute;\n        z-index: 2;\n        top: 0px;\n        left: 0px;\n        width: 100%;\n        height: 100%;\n        background: rgba($color__black, 0.5);\n        color: $color__white;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n    .video-block__scale {\n        width: 1.625rem;\n        height: 1.625rem;\n        padding:0;\n        border-radius: 50%;\n        border: none;\n        outline: none;\n        box-shadow: 1px 1px 4px 1px rgba(black, 0.25);\n        background: rgba($color__white, 0.75);\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        // color: $color__primary;\n        color: $color__ternary;\n        font-size: 1rem;\n        position: absolute;\n        top: 0.6125rem;\n        right: 0.6125rem;\n        z-index: 3;\n        transition: all 0.3s linear;\n        border: 1px solid $color__ternary;\n        border-width: 1.5px;\n        &:hover {\n            background: $color__white;\n        }\n    }\n\n    .video-block__image {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n        display: block;\n        position: absolute;\n        top:0;\n    }\n\n    &.video-block--nocamera {\n        .video-block__video {\n            display: none;\n        }\n    }\n\n    .audio-meter-container {\n        position: absolute;\n        bottom: 1.5rem;\n        left: 0px;\n        right: 0px;\n        z-index: 1;\n\n        &.audio-meter-container--vertical {\n            bottom: 1.5rem;\n            top: 1.5rem;\n            height: auto;\n            right: 1.5rem;\n            left: auto;\n        }\n    }\n\n    .video-block__muted {\n        position: absolute;\n        left: 0px;\n        right: 0px;\n        top: 0px;\n        bottom: 0px;\n        z-index: 2;\n        color: $color__white;\n        font-size: 3rem;\n        font-size: 5vw;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        opacity: 0.5;\n    }\n    @include functions.responsiveNewTablet {\n        .video-block__scale {\n            width: 1.25rem;\n            height: 1.25rem;\n            font-size: 0.75rem;\n        }\n    }\n}\n\n\n\n\n// -----------------------------\n// ALERT\n// -----------------------------\n.alert {\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: center;\n    width: 100%;\n    padding: 0.5rem 0.75rem;\n    border-radius: 0.5rem;\n    background: #ffffff;\n    color: $color__red;\n    font-size: inherit;    \n    font-weight: 600;\n    margin: 0px auto 1rem;\n\n    .alert__icon {\n        font-size: 1.5rem;\n        margin-right: 0.5rem;\n    }\n}\n\n\n\n\n// -----------------------------\n// AUDIO METER\n// -----------------------------\n.audio-meter-container {\n  width: 100%;\n  height: 0.5rem;\n  border: 1px solid $color__primary;\n  background: $color__white;\n  border-radius: 0.25rem;\n  overflow: hidden;\n  .audio-meter-inner {\n    height: 100%;\n    background: $color__primary;\n    transition: width 0.3s linear;\n  }\n\n  &.audio-meter-container--vertical {\n    width: 0.5rem;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    .audio-meter-inner {\n      width: 100%;\n      height: auto;\n      margin-top: auto;\n      margin-bottom: 0;\n    }\n  }\n}\n\n\n// -----------------------------\n// LOADER\n// -----------------------------\n@keyframes spinnerAnim {\n    100% {\n        transform: rotate(360deg);\n    }\n}\n.loader {\n    position: fixed;\n    top: 0px;\n    left: 0px;\n    right: 0px;\n    bottom: 0px;\n    z-index: 110;\n    background: rgba($color__black, 0.7);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    .loader__inner {\n        background: $color__white;\n        width: 12.5rem;\n        height: 12.5rem;\n        border-radius: 1rem;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    .loader__spinner {\n        width: 50%;\n        height: 50%;\n        border-radius: 50%;\n        border: 0.375rem solid $color__primary;\n        border-bottom-color: transparent;\n        border-top-color: transparent;\n        animation: spinnerAnim 2s infinite linear;\n    }\n}\n\n\n\n\n\n// -----------------------------\n// TABS\n// -----------------------------\n.tabs {\n    max-width: 31.5rem;\n    margin: 0px auto;\n    flex: 1 0 auto;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: stretch;\n    justify-content: center;\n    position: relative;\n    &::after {\n        content: '';\n        display: block;\n        width: 100%;\n        height: 1px;\n        background: #EEE7E1;\n        position: absolute;\n        bottom: -1px;\n        left: 0px;\n    }\n    .tab {\n        cursor: pointer;\n        flex: 1 0 auto;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background: $color__white;\n        border-radius: 1rem 1rem 0px 0px;\n        padding: 0.625rem 1.875rem;\n        box-shadow: 1px 0px 2px rgba($color__black, 0.3);\n        font-size: 1rem;\n        border-bottom: 3px solid transparent;\n        &.active {\n            border-bottom-color: $color__orange;\n        }\n        span {\n            display: flex;\n            flex-wrap: nowrap;\n            align-items: center;\n            justify-content: center;\n        }\n        & + .tab {\n            margin-left: 0.75rem;\n        }\n        i {\n            margin-right: 0.25rem;\n        }\n    }\n    @include functions.responsiveSmartphone {\n        flex-wrap: nowrap;\n        max-width: 100%;\n        width: 100%;\n        padding-top: 0.75rem;\n        &::after {\n            top: 0px;\n            bottom: auto;\n            left: -0.75rem;\n            right: -0.75rem;\n            width: auto;\n            box-shadow: 0px -1px 2px rgba(0, 0, 0, 0.3);\n        }\n        .tab {\n            padding: 0.25rem 1.25rem;\n            border-radius: 0px;\n            box-shadow: none;\n            font-size: 0.875rem;\n            flex: 0 0 auto;\n            span {\n                flex-direction: column;\n            }\n        }\n    }\n}\n.tab-content {\n    padding: 1.625rem 0.5rem;\n}\n.tabs-wrapper {\n    @include functions.responsiveSmartphone {\n        display: flex;\n        flex-direction: column;\n        .tabs {\n            margin-top: auto;\n            order: 2;\n            flex: 0 0 auto;\n        }\n        .tab-content {\n            order: 1;\n            flex: 1 1 auto;\n            overflow: hidden;\n            overflow-y: auto;\n        }\n    }\n}\n\n.flashlight-toggle {\n    position: absolute;\n    top: 1rem;\n    left: 1rem;\n    z-index: 2;\n    width: 2.5rem;\n    height: 2.5rem;\n    border: 2px solid $color__white;\n    color: $color__white;\n    background: rgba($color__white, 0.3);\n    border-radius: 50%;\n    box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.25);\n    font-size: 1.5rem;\n    display: none;\n    align-items: center;\n    justify-content: center;\n    &:hover {\n        background: rgba($color__white, 0.4);\n    }\n\n    &--active {\n        background: $color__orange;\n        border-color: $color__orange;\n        &:hover {\n            background: darken($color__orange, 10%);\n            border-color: darken($color__orange, 10%);\n        }\n    }\n    @include functions.responsiveSmartphone {\n        display: flex;\n    }\n}","@use './variables' as *;\n\n/// Base path for assets (fonts, images...),\n/// should not include trailing slash\n/// @access public\n/// @type String\n$asset-base-path: '../assets' !default;\n\n/// Asset URL builder\n/// @access private\n/// @param {String} $type - Asset type, matching folder name\n/// @param {String} $file - Asset file name, including extension\n/// @return {URL} - A `url()` function leading to the asset\n@function asset($type, $file, $before: '') {\n  @return url($before + $asset-base-path + '/' + $type + '/' + $file);\n}\n\n/// Image asset helper\n/// @access public\n/// @param {String} $file - Asset file name, including extension\n/// @return {URL} - A `url()` function leading to the image\n/// @require {function} asset\n@function image($file, $before: '') {\n  @return asset('images', $file, $before);\n}\n\n/// Image asset helper\n/// @access public\n/// @param {String} $file - Asset file name, including extension\n/// @return {URL} - A `url()` function leading to the image\n/// @require {function} asset\n@function picto($file, $before: '') {\n  @return asset('images/pictos', $file, $before);\n}\n\n/// Font asset helper\n/// @access public\n/// @param {String} $file - Asset file name, including extension\n/// @return {URL} - A `url()` function leading to the font\n/// @require {function} asset\n@function font($file, $before: '') {\n  @return asset('fonts', $file, $before);\n}\n\n\n// width < 1200px\n@mixin responsiveTablet {\n  @media (max-width: $screen-xl - 1px) {\n    @content;\n  }\n}\n\n// width < 768px OR height < 576px\n@mixin responsiveMobile {\n  @media (max-width: $screen-md - 1px), (max-height: $screen-sm - 1px) {\n    @content;\n  }\n}\n\n// width < 576px\n@mixin responsiveSmartphone {\n  @media (max-width: $screen-sm - 1px) {\n    @content;\n  }\n}\n\n@mixin responsiveWidth($width) {\n  @media (max-width: $width) {\n    @content;\n  }\n}\n\n@mixin responsiveHeight($height) {\n  @media (max-height: $height) {\n    @content;\n  }\n}\n\n@mixin responsiveWidthOrHeight($width, $height) {\n  @media (max-width: $width), (max-height: $height) {\n    @content;\n  }\n}\n\n@mixin responsiveNewTablet {\n  @include responsiveWidthOrHeight($screen-lg - 1px, 699px) {\n    @content;\n  }\n}","@use './abstracts/variables' as *;\n@use './abstracts/functions';\n\n\n// -------\n// Fieldset\n// -------\n.fieldset {\n  margin: 0px 0px 0.625rem;\n  &__title {\n    font-family: $font__ternary;\n    font-weight: 500;\n    font-size: 1rem;\n    line-height: 1;\n    text-align: center;\n    vertical-align: middle;\n    margin: 0px 0px 0.625rem;\n  }\n\n  &__inner {\n    border-radius: 1rem;\n    padding: 0.625rem;\n    border: 1px solid #959292;\n  }\n}\n\n\n// -------\n// Inputs\n// -------\n.file-item-select {\n  margin: 0px;\n  padding: 0px 0px;\n  list-style-type: none;\n  overflow: auto;\n  height: 100%;\n}\n.file-item-option {\n  display: flex;\n  flex-wrap: nowrap;\n  width: 100%;\n  font-size: 1rem;\n  padding: 0.25rem 0.75rem 0.25rem 0px;\n  &__input {\n    margin: 0px;\n    margin-right: 0.625rem;\n    flex: 0 0 1.125rem;\n    width: 1rem;\n    height: 1rem;\n    border: 2px solid $color__primary;\n  }\n  &__icon {\n    flex: 0 0 1.125rem;\n    color: $color__orange;\n    margin-right: 0.75rem;\n  }\n  &__label {\n    font-weight: 500;\n    flex: 1 1 auto;\n  }\n  &__preview,\n  &__download {\n    cursor: pointer;\n    flex: 0 0 1.125rem;\n    font-size: 1.125rem;\n  }\n  &__preview {\n    margin-right: 0.75rem;\n  }\n}\n\n\n.input-file-custom {\n  display: inline-block;\n  margin: 0px auto;\n  position: relative;\n\n  &__input {\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    bottom: 0px;\n    right: 0px;\n    z-index: 1;\n    opacity: 0;\n  }\n}\n\n\n.form-input {\n  width: 100%;\n  max-width: 303px;\n  margin-bottom: 0.75rem;\n\n  .doctor-form & {\n    margin-bottom: 0.5rem;;\n  }\n\n  &--date {\n    max-width: 131px;\n  }\n\n  &--zipcode {\n    max-width: 140px;\n  }\n  &--select,\n  &--upload,\n  &--multiselect-files,\n  &--motif_consultation {\n    max-width: 100%;\n    flex: 1 1 auto;\n  }\n  &--textarea {\n    max-width: 100%;\n    flex: 1 1 auto;\n\n    .form-input__input {\n      height: 6.5rem;\n    }\n  }\n\n  &__label {\n    display: block;\n    font-family: $font__quaternary;\n    font-weight: 600;\n    font-size: 1rem;\n    line-height: 1.1;\n    margin: 0px 0px 0.5rem;\n    \n    .doctor-form & {\n      margin-bottom: 0.25rem;\n    }\n\n    small {\n      font-weight: 400;\n      font-size: 1rem;\n      margin-left: 0.5rem;\n    }\n  }\n\n  &__input {\n    display: block;\n    width: 100%;\n    margin: 0px;\n    border-radius: 1rem;\n    padding: 0.375rem 1rem;\n    box-shadow: 0px 1px 4px 1px rgba(0, 0, 0, 0.21) inset;\n    font-family: $font__quaternary;\n    font-weight: 500;\n    font-size: 0.875rem;\n    line-height: 1.1;\n    color: $color__primary-dark;\n    border: none;\n    outline: none;\n\n    &::placeholder {\n      color: $color__primary-dark;\n    }\n  }\n\n  &__input__error {\n    box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.21) inset;\n    border: 0.2rem solid #FF4958;\n  }\n\n  &__multiselect {\n    width: 100%;\n    padding: 0.375rem 1.25rem;\n    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.25) inset;\n    border-radius: 1.5rem;\n    background: $color__white;\n    height: 100px;\n    overflow: hidden;\n  }\n\n  &__description {\n    margin: 0px 0px 0.75rem;\n  }\n\n  &__file {\n    text-align: center;\n  }\n\n  &__select {\n    background: #FDFBFB;\n    border: 1px solid #AAA5A4;\n    width: 100%;\n    padding: 0.375rem 1rem;\n    border-radius: 1.5rem;\n    font-family: $font__quaternary;\n    font-weight: 600;\n    font-size: 0.875rem;\n    line-height: 1;\n    color: $color__primary-dark;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
